/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as workersWorkersRouteImport } from "./routes/(workers)/workers"
import { Route as toursToursRouteImport } from "./routes/(tours)/tours"
import { Route as servicesServicesRouteImport } from "./routes/(services)/services"
import { Route as regionsRegionsRouteImport } from "./routes/(regions)/regions"
import { Route as providersProvidersRouteImport } from "./routes/(providers)/providers"
import { Route as operationsOperationsRouteImport } from "./routes/(operations)/operations"
import { Route as hotelsHotelsRouteImport } from "./routes/(hotels)/hotels"
import { Route as guidesGuidesRouteImport } from "./routes/(guides)/guides"
import { Route as departmentsDepartmentsRouteImport } from "./routes/(departments)/departments"
import { Route as agenciesAgenciesRouteImport } from "./routes/(agencies)/agencies"
import { Route as reservationsReservationsIndexRouteImport } from "./routes/(reservations)/reservations.index"
import { Route as workersWorkersSheetRouteImport } from "./routes/(workers)/workers/_sheet"
import { Route as toursToursSheetRouteImport } from "./routes/(tours)/tours/_sheet"
import { Route as tourDaysTourDaysIdRouteImport } from "./routes/(tour-days)/tour-days.$id"
import { Route as tourAgenciesTourAgenciesIdRouteImport } from "./routes/(tour-agencies)/tour-agencies.$id"
import { Route as servicesServicesSheetRouteImport } from "./routes/(services)/services/_sheet"
import { Route as serviceProvidersServiceProvidersIdRouteImport } from "./routes/(service-providers)/service-providers.$id"
import { Route as reservationsReservationsNewRouteImport } from "./routes/(reservations)/reservations/new"
import { Route as regionsRegionsSheetRouteImport } from "./routes/(regions)/regions/_sheet"
import { Route as providersProvidersSheetRouteImport } from "./routes/(providers)/providers/_sheet"
import { Route as paymentsPaymentsIdRouteImport } from "./routes/(payments)/payments.$id"
import { Route as paymentAdjustmentsPaymentAdjustmentsIdRouteImport } from "./routes/(payment-adjustments)/payment-adjustments.$id"
import { Route as hotelsHotelsSheetRouteImport } from "./routes/(hotels)/hotels/_sheet"
import { Route as hotelRoomsHotelRoomsIdRouteImport } from "./routes/(hotel-rooms)/hotel-rooms.$id"
import { Route as guidesGuidesSheetRouteImport } from "./routes/(guides)/guides/_sheet"
import { Route as departmentsDepartmentsSheetRouteImport } from "./routes/(departments)/departments/_sheet"
import { Route as agenciesAgenciesSheetRouteImport } from "./routes/(agencies)/agencies/_sheet"
import { Route as reservationsReservationsCalendarIndexRouteImport } from "./routes/(reservations)/reservations/calendar/index"
import { Route as reservationsReservationsIdIndexRouteImport } from "./routes/(reservations)/reservations/$id.index"
import { Route as workersWorkersSheetNewRouteImport } from "./routes/(workers)/workers/_sheet.new"
import { Route as toursToursSheetNewRouteImport } from "./routes/(tours)/tours/_sheet.new"
import { Route as tourAgenciesTourAgenciesIdSheetRouteImport } from "./routes/(tour-agencies)/tour-agencies.$id/_sheet"
import { Route as servicesServicesSheetNewRouteImport } from "./routes/(services)/services/_sheet.new"
import { Route as serviceProvidersServiceProvidersIdSheetRouteImport } from "./routes/(service-providers)/service-providers.$id/_sheet"
import { Route as reservationsReservationsIdFulfillmentsRouteImport } from "./routes/(reservations)/reservations/$id.fulfillments"
import { Route as reservationsReservationsIdEditRouteImport } from "./routes/(reservations)/reservations/$id.edit"
import { Route as regionsRegionsSheetNewRouteImport } from "./routes/(regions)/regions/_sheet.new"
import { Route as providersProvidersSheetNewRouteImport } from "./routes/(providers)/providers/_sheet.new"
import { Route as paymentsPaymentsIdSheetRouteImport } from "./routes/(payments)/payments.$id._sheet"
import { Route as paymentAdjustmentsPaymentAdjustmentsIdSheetRouteImport } from "./routes/(payment-adjustments)/payment-adjustments.$id/_sheet"
import { Route as hotelsHotelsSheetNewRouteImport } from "./routes/(hotels)/hotels/_sheet.new"
import { Route as hotelRoomsHotelRoomsIdSheetRouteImport } from "./routes/(hotel-rooms)/hotel-rooms.$id/_sheet"
import { Route as guidesGuidesSheetNewRouteImport } from "./routes/(guides)/guides/_sheet.new"
import { Route as departmentsDepartmentsSheetNewRouteImport } from "./routes/(departments)/departments/_sheet.new"
import { Route as agenciesAgenciesSheetNewRouteImport } from "./routes/(agencies)/agencies/_sheet.new"
import { Route as workersWorkersSheetIdIndexRouteImport } from "./routes/(workers)/workers/_sheet.$id.index"
import { Route as toursToursSheetIdIndexRouteImport } from "./routes/(tours)/tours/_sheet.$id.index"
import { Route as servicesServicesSheetIdIndexRouteImport } from "./routes/(services)/services/_sheet.$id.index"
import { Route as reservationsReservationsCalendarNewIndexRouteImport } from "./routes/(reservations)/reservations/calendar/new.index"
import { Route as reservationsReservationsCalendarIdIndexRouteImport } from "./routes/(reservations)/reservations/calendar/$id.index"
import { Route as regionsRegionsSheetIdIndexRouteImport } from "./routes/(regions)/regions/_sheet.$id.index"
import { Route as providersProvidersSheetIdIndexRouteImport } from "./routes/(providers)/providers/_sheet.$id.index"
import { Route as hotelsHotelsSheetIdIndexRouteImport } from "./routes/(hotels)/hotels/_sheet.$id.index"
import { Route as guidesGuidesSheetIdIndexRouteImport } from "./routes/(guides)/guides/_sheet.$id.index"
import { Route as departmentsDepartmentsSheetIdIndexRouteImport } from "./routes/(departments)/departments/_sheet.$id.index"
import { Route as agenciesAgenciesSheetIdIndexRouteImport } from "./routes/(agencies)/agencies/_sheet.$id.index"
import { Route as workersWorkersSheetIdEditRouteImport } from "./routes/(workers)/workers/_sheet.$id.edit"
import { Route as toursToursSheetIdEditRouteImport } from "./routes/(tours)/tours/_sheet.$id.edit"
import { Route as tourAgenciesTourAgenciesIdSheetNewRouteImport } from "./routes/(tour-agencies)/tour-agencies.$id/_sheet.new"
import { Route as servicesServicesSheetIdEditRouteImport } from "./routes/(services)/services/_sheet.$id.edit"
import { Route as serviceProvidersServiceProvidersIdSheetNewRouteImport } from "./routes/(service-providers)/service-providers.$id/_sheet.new"
import { Route as reservationsReservationsCalendarIdFulfillmentsRouteImport } from "./routes/(reservations)/reservations/calendar/$id.fulfillments"
import { Route as reservationsReservationsCalendarIdEditRouteImport } from "./routes/(reservations)/reservations/calendar/$id.edit"
import { Route as regionsRegionsSheetIdEditRouteImport } from "./routes/(regions)/regions/_sheet.$id.edit"
import { Route as providersProvidersSheetIdEditRouteImport } from "./routes/(providers)/providers/_sheet.$id.edit"
import { Route as paymentsPaymentsIdSheetPidRouteImport } from "./routes/(payments)/payments.$id._sheet.$pid"
import { Route as paymentAdjustmentsPaymentAdjustmentsIdSheetNewRouteImport } from "./routes/(payment-adjustments)/payment-adjustments.$id/_sheet.new"
import { Route as paymentAdjustmentsPaymentAdjustmentsIdSheetPidRouteImport } from "./routes/(payment-adjustments)/payment-adjustments.$id/_sheet.$pid"
import { Route as hotelsHotelsSheetIdEditRouteImport } from "./routes/(hotels)/hotels/_sheet.$id.edit"
import { Route as hotelRoomsHotelRoomsIdSheetNewRouteImport } from "./routes/(hotel-rooms)/hotel-rooms.$id/_sheet.new"
import { Route as hotelRoomsHotelRoomsIdSheetRidRouteImport } from "./routes/(hotel-rooms)/hotel-rooms.$id/_sheet.$rid"
import { Route as guidesGuidesSheetIdEditRouteImport } from "./routes/(guides)/guides/_sheet.$id.edit"
import { Route as departmentsDepartmentsSheetIdEditRouteImport } from "./routes/(departments)/departments/_sheet.$id.edit"
import { Route as agenciesAgenciesSheetIdEditRouteImport } from "./routes/(agencies)/agencies/_sheet.$id.edit"
import { Route as tourAgenciesTourAgenciesIdSheetEditTaIdRouteImport } from "./routes/(tour-agencies)/tour-agencies.$id/_sheet.edit.$taId"
import { Route as serviceProvidersServiceProvidersIdSheetEditSpIdRouteImport } from "./routes/(service-providers)/service-providers.$id/_sheet.edit.$spId"
import { Route as paymentsPaymentsIdSheetDepositNewRouteImport } from "./routes/(payments)/payments.$id._sheet.deposit.new"
import { Route as paymentsPaymentsIdSheetBalanceNewRouteImport } from "./routes/(payments)/payments.$id._sheet.balance.new"
import { Route as reservationsReservationsIdFulfillmentsNewServiceIndexRouteImport } from "./routes/(reservations)/reservations/$id.fulfillments.new.service.index"
import { Route as reservationsReservationsIdFulfillmentsNewHotelIndexRouteImport } from "./routes/(reservations)/reservations/$id.fulfillments.new.hotel.index"
import { Route as reservationsReservationsIdFulfillmentsFidEditIndexRouteImport } from "./routes/(reservations)/reservations/$id.fulfillments.$fid.edit.index"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const workersWorkersRoute = workersWorkersRouteImport.update({
  id: "/(workers)/workers",
  path: "/workers",
  getParentRoute: () => rootRouteImport,
} as any)
const toursToursRoute = toursToursRouteImport.update({
  id: "/(tours)/tours",
  path: "/tours",
  getParentRoute: () => rootRouteImport,
} as any)
const servicesServicesRoute = servicesServicesRouteImport.update({
  id: "/(services)/services",
  path: "/services",
  getParentRoute: () => rootRouteImport,
} as any)
const regionsRegionsRoute = regionsRegionsRouteImport.update({
  id: "/(regions)/regions",
  path: "/regions",
  getParentRoute: () => rootRouteImport,
} as any)
const providersProvidersRoute = providersProvidersRouteImport.update({
  id: "/(providers)/providers",
  path: "/providers",
  getParentRoute: () => rootRouteImport,
} as any)
const operationsOperationsRoute = operationsOperationsRouteImport.update({
  id: "/(operations)/operations",
  path: "/operations",
  getParentRoute: () => rootRouteImport,
} as any)
const hotelsHotelsRoute = hotelsHotelsRouteImport.update({
  id: "/(hotels)/hotels",
  path: "/hotels",
  getParentRoute: () => rootRouteImport,
} as any)
const guidesGuidesRoute = guidesGuidesRouteImport.update({
  id: "/(guides)/guides",
  path: "/guides",
  getParentRoute: () => rootRouteImport,
} as any)
const departmentsDepartmentsRoute = departmentsDepartmentsRouteImport.update({
  id: "/(departments)/departments",
  path: "/departments",
  getParentRoute: () => rootRouteImport,
} as any)
const agenciesAgenciesRoute = agenciesAgenciesRouteImport.update({
  id: "/(agencies)/agencies",
  path: "/agencies",
  getParentRoute: () => rootRouteImport,
} as any)
const reservationsReservationsIndexRoute =
  reservationsReservationsIndexRouteImport.update({
    id: "/(reservations)/reservations/",
    path: "/reservations/",
    getParentRoute: () => rootRouteImport,
  } as any)
const workersWorkersSheetRoute = workersWorkersSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => workersWorkersRoute,
} as any)
const toursToursSheetRoute = toursToursSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => toursToursRoute,
} as any)
const tourDaysTourDaysIdRoute = tourDaysTourDaysIdRouteImport.update({
  id: "/(tour-days)/tour-days/$id",
  path: "/tour-days/$id",
  getParentRoute: () => rootRouteImport,
} as any)
const tourAgenciesTourAgenciesIdRoute =
  tourAgenciesTourAgenciesIdRouteImport.update({
    id: "/(tour-agencies)/tour-agencies/$id",
    path: "/tour-agencies/$id",
    getParentRoute: () => rootRouteImport,
  } as any)
const servicesServicesSheetRoute = servicesServicesSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => servicesServicesRoute,
} as any)
const serviceProvidersServiceProvidersIdRoute =
  serviceProvidersServiceProvidersIdRouteImport.update({
    id: "/(service-providers)/service-providers/$id",
    path: "/service-providers/$id",
    getParentRoute: () => rootRouteImport,
  } as any)
const reservationsReservationsNewRoute =
  reservationsReservationsNewRouteImport.update({
    id: "/(reservations)/reservations/new",
    path: "/reservations/new",
    getParentRoute: () => rootRouteImport,
  } as any)
const regionsRegionsSheetRoute = regionsRegionsSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => regionsRegionsRoute,
} as any)
const providersProvidersSheetRoute = providersProvidersSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => providersProvidersRoute,
} as any)
const paymentsPaymentsIdRoute = paymentsPaymentsIdRouteImport.update({
  id: "/(payments)/payments/$id",
  path: "/payments/$id",
  getParentRoute: () => rootRouteImport,
} as any)
const paymentAdjustmentsPaymentAdjustmentsIdRoute =
  paymentAdjustmentsPaymentAdjustmentsIdRouteImport.update({
    id: "/(payment-adjustments)/payment-adjustments/$id",
    path: "/payment-adjustments/$id",
    getParentRoute: () => rootRouteImport,
  } as any)
const hotelsHotelsSheetRoute = hotelsHotelsSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => hotelsHotelsRoute,
} as any)
const hotelRoomsHotelRoomsIdRoute = hotelRoomsHotelRoomsIdRouteImport.update({
  id: "/(hotel-rooms)/hotel-rooms/$id",
  path: "/hotel-rooms/$id",
  getParentRoute: () => rootRouteImport,
} as any)
const guidesGuidesSheetRoute = guidesGuidesSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => guidesGuidesRoute,
} as any)
const departmentsDepartmentsSheetRoute =
  departmentsDepartmentsSheetRouteImport.update({
    id: "/_sheet",
    getParentRoute: () => departmentsDepartmentsRoute,
  } as any)
const agenciesAgenciesSheetRoute = agenciesAgenciesSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => agenciesAgenciesRoute,
} as any)
const reservationsReservationsCalendarIndexRoute =
  reservationsReservationsCalendarIndexRouteImport.update({
    id: "/(reservations)/reservations/calendar/",
    path: "/reservations/calendar/",
    getParentRoute: () => rootRouteImport,
  } as any)
const reservationsReservationsIdIndexRoute =
  reservationsReservationsIdIndexRouteImport.update({
    id: "/(reservations)/reservations/$id/",
    path: "/reservations/$id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const workersWorkersSheetNewRoute = workersWorkersSheetNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => workersWorkersSheetRoute,
} as any)
const toursToursSheetNewRoute = toursToursSheetNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => toursToursSheetRoute,
} as any)
const tourAgenciesTourAgenciesIdSheetRoute =
  tourAgenciesTourAgenciesIdSheetRouteImport.update({
    id: "/_sheet",
    getParentRoute: () => tourAgenciesTourAgenciesIdRoute,
  } as any)
const servicesServicesSheetNewRoute =
  servicesServicesSheetNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const serviceProvidersServiceProvidersIdSheetRoute =
  serviceProvidersServiceProvidersIdSheetRouteImport.update({
    id: "/_sheet",
    getParentRoute: () => serviceProvidersServiceProvidersIdRoute,
  } as any)
const reservationsReservationsIdFulfillmentsRoute =
  reservationsReservationsIdFulfillmentsRouteImport.update({
    id: "/(reservations)/reservations/$id/fulfillments",
    path: "/reservations/$id/fulfillments",
    getParentRoute: () => rootRouteImport,
  } as any)
const reservationsReservationsIdEditRoute =
  reservationsReservationsIdEditRouteImport.update({
    id: "/(reservations)/reservations/$id/edit",
    path: "/reservations/$id/edit",
    getParentRoute: () => rootRouteImport,
  } as any)
const regionsRegionsSheetNewRoute = regionsRegionsSheetNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => regionsRegionsSheetRoute,
} as any)
const providersProvidersSheetNewRoute =
  providersProvidersSheetNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => providersProvidersSheetRoute,
  } as any)
const paymentsPaymentsIdSheetRoute = paymentsPaymentsIdSheetRouteImport.update({
  id: "/_sheet",
  getParentRoute: () => paymentsPaymentsIdRoute,
} as any)
const paymentAdjustmentsPaymentAdjustmentsIdSheetRoute =
  paymentAdjustmentsPaymentAdjustmentsIdSheetRouteImport.update({
    id: "/_sheet",
    getParentRoute: () => paymentAdjustmentsPaymentAdjustmentsIdRoute,
  } as any)
const hotelsHotelsSheetNewRoute = hotelsHotelsSheetNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => hotelsHotelsSheetRoute,
} as any)
const hotelRoomsHotelRoomsIdSheetRoute =
  hotelRoomsHotelRoomsIdSheetRouteImport.update({
    id: "/_sheet",
    getParentRoute: () => hotelRoomsHotelRoomsIdRoute,
  } as any)
const guidesGuidesSheetNewRoute = guidesGuidesSheetNewRouteImport.update({
  id: "/new",
  path: "/new",
  getParentRoute: () => guidesGuidesSheetRoute,
} as any)
const departmentsDepartmentsSheetNewRoute =
  departmentsDepartmentsSheetNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => departmentsDepartmentsSheetRoute,
  } as any)
const agenciesAgenciesSheetNewRoute =
  agenciesAgenciesSheetNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => agenciesAgenciesSheetRoute,
  } as any)
const workersWorkersSheetIdIndexRoute =
  workersWorkersSheetIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => workersWorkersSheetRoute,
  } as any)
const toursToursSheetIdIndexRoute = toursToursSheetIdIndexRouteImport.update({
  id: "/$id/",
  path: "/$id/",
  getParentRoute: () => toursToursSheetRoute,
} as any)
const servicesServicesSheetIdIndexRoute =
  servicesServicesSheetIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const reservationsReservationsCalendarNewIndexRoute =
  reservationsReservationsCalendarNewIndexRouteImport.update({
    id: "/(reservations)/reservations/calendar/new/",
    path: "/reservations/calendar/new/",
    getParentRoute: () => rootRouteImport,
  } as any)
const reservationsReservationsCalendarIdIndexRoute =
  reservationsReservationsCalendarIdIndexRouteImport.update({
    id: "/(reservations)/reservations/calendar/$id/",
    path: "/reservations/calendar/$id/",
    getParentRoute: () => rootRouteImport,
  } as any)
const regionsRegionsSheetIdIndexRoute =
  regionsRegionsSheetIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => regionsRegionsSheetRoute,
  } as any)
const providersProvidersSheetIdIndexRoute =
  providersProvidersSheetIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => providersProvidersSheetRoute,
  } as any)
const hotelsHotelsSheetIdIndexRoute =
  hotelsHotelsSheetIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => hotelsHotelsSheetRoute,
  } as any)
const guidesGuidesSheetIdIndexRoute =
  guidesGuidesSheetIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => guidesGuidesSheetRoute,
  } as any)
const departmentsDepartmentsSheetIdIndexRoute =
  departmentsDepartmentsSheetIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => departmentsDepartmentsSheetRoute,
  } as any)
const agenciesAgenciesSheetIdIndexRoute =
  agenciesAgenciesSheetIdIndexRouteImport.update({
    id: "/$id/",
    path: "/$id/",
    getParentRoute: () => agenciesAgenciesSheetRoute,
  } as any)
const workersWorkersSheetIdEditRoute =
  workersWorkersSheetIdEditRouteImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => workersWorkersSheetRoute,
  } as any)
const toursToursSheetIdEditRoute = toursToursSheetIdEditRouteImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => toursToursSheetRoute,
} as any)
const tourAgenciesTourAgenciesIdSheetNewRoute =
  tourAgenciesTourAgenciesIdSheetNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => tourAgenciesTourAgenciesIdSheetRoute,
  } as any)
const servicesServicesSheetIdEditRoute =
  servicesServicesSheetIdEditRouteImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => servicesServicesSheetRoute,
  } as any)
const serviceProvidersServiceProvidersIdSheetNewRoute =
  serviceProvidersServiceProvidersIdSheetNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => serviceProvidersServiceProvidersIdSheetRoute,
  } as any)
const reservationsReservationsCalendarIdFulfillmentsRoute =
  reservationsReservationsCalendarIdFulfillmentsRouteImport.update({
    id: "/(reservations)/reservations/calendar/$id/fulfillments",
    path: "/reservations/calendar/$id/fulfillments",
    getParentRoute: () => rootRouteImport,
  } as any)
const reservationsReservationsCalendarIdEditRoute =
  reservationsReservationsCalendarIdEditRouteImport.update({
    id: "/(reservations)/reservations/calendar/$id/edit",
    path: "/reservations/calendar/$id/edit",
    getParentRoute: () => rootRouteImport,
  } as any)
const regionsRegionsSheetIdEditRoute =
  regionsRegionsSheetIdEditRouteImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => regionsRegionsSheetRoute,
  } as any)
const providersProvidersSheetIdEditRoute =
  providersProvidersSheetIdEditRouteImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => providersProvidersSheetRoute,
  } as any)
const paymentsPaymentsIdSheetPidRoute =
  paymentsPaymentsIdSheetPidRouteImport.update({
    id: "/$pid",
    path: "/$pid",
    getParentRoute: () => paymentsPaymentsIdSheetRoute,
  } as any)
const paymentAdjustmentsPaymentAdjustmentsIdSheetNewRoute =
  paymentAdjustmentsPaymentAdjustmentsIdSheetNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => paymentAdjustmentsPaymentAdjustmentsIdSheetRoute,
  } as any)
const paymentAdjustmentsPaymentAdjustmentsIdSheetPidRoute =
  paymentAdjustmentsPaymentAdjustmentsIdSheetPidRouteImport.update({
    id: "/$pid",
    path: "/$pid",
    getParentRoute: () => paymentAdjustmentsPaymentAdjustmentsIdSheetRoute,
  } as any)
const hotelsHotelsSheetIdEditRoute = hotelsHotelsSheetIdEditRouteImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => hotelsHotelsSheetRoute,
} as any)
const hotelRoomsHotelRoomsIdSheetNewRoute =
  hotelRoomsHotelRoomsIdSheetNewRouteImport.update({
    id: "/new",
    path: "/new",
    getParentRoute: () => hotelRoomsHotelRoomsIdSheetRoute,
  } as any)
const hotelRoomsHotelRoomsIdSheetRidRoute =
  hotelRoomsHotelRoomsIdSheetRidRouteImport.update({
    id: "/$rid",
    path: "/$rid",
    getParentRoute: () => hotelRoomsHotelRoomsIdSheetRoute,
  } as any)
const guidesGuidesSheetIdEditRoute = guidesGuidesSheetIdEditRouteImport.update({
  id: "/$id/edit",
  path: "/$id/edit",
  getParentRoute: () => guidesGuidesSheetRoute,
} as any)
const departmentsDepartmentsSheetIdEditRoute =
  departmentsDepartmentsSheetIdEditRouteImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => departmentsDepartmentsSheetRoute,
  } as any)
const agenciesAgenciesSheetIdEditRoute =
  agenciesAgenciesSheetIdEditRouteImport.update({
    id: "/$id/edit",
    path: "/$id/edit",
    getParentRoute: () => agenciesAgenciesSheetRoute,
  } as any)
const tourAgenciesTourAgenciesIdSheetEditTaIdRoute =
  tourAgenciesTourAgenciesIdSheetEditTaIdRouteImport.update({
    id: "/edit/$taId",
    path: "/edit/$taId",
    getParentRoute: () => tourAgenciesTourAgenciesIdSheetRoute,
  } as any)
const serviceProvidersServiceProvidersIdSheetEditSpIdRoute =
  serviceProvidersServiceProvidersIdSheetEditSpIdRouteImport.update({
    id: "/edit/$spId",
    path: "/edit/$spId",
    getParentRoute: () => serviceProvidersServiceProvidersIdSheetRoute,
  } as any)
const paymentsPaymentsIdSheetDepositNewRoute =
  paymentsPaymentsIdSheetDepositNewRouteImport.update({
    id: "/deposit/new",
    path: "/deposit/new",
    getParentRoute: () => paymentsPaymentsIdSheetRoute,
  } as any)
const paymentsPaymentsIdSheetBalanceNewRoute =
  paymentsPaymentsIdSheetBalanceNewRouteImport.update({
    id: "/balance/new",
    path: "/balance/new",
    getParentRoute: () => paymentsPaymentsIdSheetRoute,
  } as any)
const reservationsReservationsIdFulfillmentsNewServiceIndexRoute =
  reservationsReservationsIdFulfillmentsNewServiceIndexRouteImport.update({
    id: "/new/service/",
    path: "/new/service/",
    getParentRoute: () => reservationsReservationsIdFulfillmentsRoute,
  } as any)
const reservationsReservationsIdFulfillmentsNewHotelIndexRoute =
  reservationsReservationsIdFulfillmentsNewHotelIndexRouteImport.update({
    id: "/new/hotel/",
    path: "/new/hotel/",
    getParentRoute: () => reservationsReservationsIdFulfillmentsRoute,
  } as any)
const reservationsReservationsIdFulfillmentsFidEditIndexRoute =
  reservationsReservationsIdFulfillmentsFidEditIndexRouteImport.update({
    id: "/$fid/edit/",
    path: "/$fid/edit/",
    getParentRoute: () => reservationsReservationsIdFulfillmentsRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/agencies": typeof agenciesAgenciesSheetRouteWithChildren
  "/departments": typeof departmentsDepartmentsSheetRouteWithChildren
  "/guides": typeof guidesGuidesSheetRouteWithChildren
  "/hotels": typeof hotelsHotelsSheetRouteWithChildren
  "/operations": typeof operationsOperationsRoute
  "/providers": typeof providersProvidersSheetRouteWithChildren
  "/regions": typeof regionsRegionsSheetRouteWithChildren
  "/services": typeof servicesServicesSheetRouteWithChildren
  "/tours": typeof toursToursSheetRouteWithChildren
  "/workers": typeof workersWorkersSheetRouteWithChildren
  "/hotel-rooms/$id": typeof hotelRoomsHotelRoomsIdSheetRouteWithChildren
  "/payment-adjustments/$id": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetRouteWithChildren
  "/payments/$id": typeof paymentsPaymentsIdSheetRouteWithChildren
  "/reservations/new": typeof reservationsReservationsNewRoute
  "/service-providers/$id": typeof serviceProvidersServiceProvidersIdSheetRouteWithChildren
  "/tour-agencies/$id": typeof tourAgenciesTourAgenciesIdSheetRouteWithChildren
  "/tour-days/$id": typeof tourDaysTourDaysIdRoute
  "/reservations": typeof reservationsReservationsIndexRoute
  "/agencies/new": typeof agenciesAgenciesSheetNewRoute
  "/departments/new": typeof departmentsDepartmentsSheetNewRoute
  "/guides/new": typeof guidesGuidesSheetNewRoute
  "/hotels/new": typeof hotelsHotelsSheetNewRoute
  "/providers/new": typeof providersProvidersSheetNewRoute
  "/regions/new": typeof regionsRegionsSheetNewRoute
  "/reservations/$id/edit": typeof reservationsReservationsIdEditRoute
  "/reservations/$id/fulfillments": typeof reservationsReservationsIdFulfillmentsRouteWithChildren
  "/services/new": typeof servicesServicesSheetNewRoute
  "/tours/new": typeof toursToursSheetNewRoute
  "/workers/new": typeof workersWorkersSheetNewRoute
  "/reservations/$id": typeof reservationsReservationsIdIndexRoute
  "/reservations/calendar": typeof reservationsReservationsCalendarIndexRoute
  "/agencies/$id/edit": typeof agenciesAgenciesSheetIdEditRoute
  "/departments/$id/edit": typeof departmentsDepartmentsSheetIdEditRoute
  "/guides/$id/edit": typeof guidesGuidesSheetIdEditRoute
  "/hotel-rooms/$id/$rid": typeof hotelRoomsHotelRoomsIdSheetRidRoute
  "/hotel-rooms/$id/new": typeof hotelRoomsHotelRoomsIdSheetNewRoute
  "/hotels/$id/edit": typeof hotelsHotelsSheetIdEditRoute
  "/payment-adjustments/$id/$pid": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetPidRoute
  "/payment-adjustments/$id/new": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetNewRoute
  "/payments/$id/$pid": typeof paymentsPaymentsIdSheetPidRoute
  "/providers/$id/edit": typeof providersProvidersSheetIdEditRoute
  "/regions/$id/edit": typeof regionsRegionsSheetIdEditRoute
  "/reservations/calendar/$id/edit": typeof reservationsReservationsCalendarIdEditRoute
  "/reservations/calendar/$id/fulfillments": typeof reservationsReservationsCalendarIdFulfillmentsRoute
  "/service-providers/$id/new": typeof serviceProvidersServiceProvidersIdSheetNewRoute
  "/services/$id/edit": typeof servicesServicesSheetIdEditRoute
  "/tour-agencies/$id/new": typeof tourAgenciesTourAgenciesIdSheetNewRoute
  "/tours/$id/edit": typeof toursToursSheetIdEditRoute
  "/workers/$id/edit": typeof workersWorkersSheetIdEditRoute
  "/agencies/$id": typeof agenciesAgenciesSheetIdIndexRoute
  "/departments/$id": typeof departmentsDepartmentsSheetIdIndexRoute
  "/guides/$id": typeof guidesGuidesSheetIdIndexRoute
  "/hotels/$id": typeof hotelsHotelsSheetIdIndexRoute
  "/providers/$id": typeof providersProvidersSheetIdIndexRoute
  "/regions/$id": typeof regionsRegionsSheetIdIndexRoute
  "/reservations/calendar/$id": typeof reservationsReservationsCalendarIdIndexRoute
  "/reservations/calendar/new": typeof reservationsReservationsCalendarNewIndexRoute
  "/services/$id": typeof servicesServicesSheetIdIndexRoute
  "/tours/$id": typeof toursToursSheetIdIndexRoute
  "/workers/$id": typeof workersWorkersSheetIdIndexRoute
  "/payments/$id/balance/new": typeof paymentsPaymentsIdSheetBalanceNewRoute
  "/payments/$id/deposit/new": typeof paymentsPaymentsIdSheetDepositNewRoute
  "/service-providers/$id/edit/$spId": typeof serviceProvidersServiceProvidersIdSheetEditSpIdRoute
  "/tour-agencies/$id/edit/$taId": typeof tourAgenciesTourAgenciesIdSheetEditTaIdRoute
  "/reservations/$id/fulfillments/$fid/edit": typeof reservationsReservationsIdFulfillmentsFidEditIndexRoute
  "/reservations/$id/fulfillments/new/hotel": typeof reservationsReservationsIdFulfillmentsNewHotelIndexRoute
  "/reservations/$id/fulfillments/new/service": typeof reservationsReservationsIdFulfillmentsNewServiceIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/agencies": typeof agenciesAgenciesSheetRouteWithChildren
  "/departments": typeof departmentsDepartmentsSheetRouteWithChildren
  "/guides": typeof guidesGuidesSheetRouteWithChildren
  "/hotels": typeof hotelsHotelsSheetRouteWithChildren
  "/operations": typeof operationsOperationsRoute
  "/providers": typeof providersProvidersSheetRouteWithChildren
  "/regions": typeof regionsRegionsSheetRouteWithChildren
  "/services": typeof servicesServicesSheetRouteWithChildren
  "/tours": typeof toursToursSheetRouteWithChildren
  "/workers": typeof workersWorkersSheetRouteWithChildren
  "/hotel-rooms/$id": typeof hotelRoomsHotelRoomsIdSheetRouteWithChildren
  "/payment-adjustments/$id": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetRouteWithChildren
  "/payments/$id": typeof paymentsPaymentsIdSheetRouteWithChildren
  "/reservations/new": typeof reservationsReservationsNewRoute
  "/service-providers/$id": typeof serviceProvidersServiceProvidersIdSheetRouteWithChildren
  "/tour-agencies/$id": typeof tourAgenciesTourAgenciesIdSheetRouteWithChildren
  "/tour-days/$id": typeof tourDaysTourDaysIdRoute
  "/reservations": typeof reservationsReservationsIndexRoute
  "/agencies/new": typeof agenciesAgenciesSheetNewRoute
  "/departments/new": typeof departmentsDepartmentsSheetNewRoute
  "/guides/new": typeof guidesGuidesSheetNewRoute
  "/hotels/new": typeof hotelsHotelsSheetNewRoute
  "/providers/new": typeof providersProvidersSheetNewRoute
  "/regions/new": typeof regionsRegionsSheetNewRoute
  "/reservations/$id/edit": typeof reservationsReservationsIdEditRoute
  "/reservations/$id/fulfillments": typeof reservationsReservationsIdFulfillmentsRouteWithChildren
  "/services/new": typeof servicesServicesSheetNewRoute
  "/tours/new": typeof toursToursSheetNewRoute
  "/workers/new": typeof workersWorkersSheetNewRoute
  "/reservations/$id": typeof reservationsReservationsIdIndexRoute
  "/reservations/calendar": typeof reservationsReservationsCalendarIndexRoute
  "/agencies/$id/edit": typeof agenciesAgenciesSheetIdEditRoute
  "/departments/$id/edit": typeof departmentsDepartmentsSheetIdEditRoute
  "/guides/$id/edit": typeof guidesGuidesSheetIdEditRoute
  "/hotel-rooms/$id/$rid": typeof hotelRoomsHotelRoomsIdSheetRidRoute
  "/hotel-rooms/$id/new": typeof hotelRoomsHotelRoomsIdSheetNewRoute
  "/hotels/$id/edit": typeof hotelsHotelsSheetIdEditRoute
  "/payment-adjustments/$id/$pid": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetPidRoute
  "/payment-adjustments/$id/new": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetNewRoute
  "/payments/$id/$pid": typeof paymentsPaymentsIdSheetPidRoute
  "/providers/$id/edit": typeof providersProvidersSheetIdEditRoute
  "/regions/$id/edit": typeof regionsRegionsSheetIdEditRoute
  "/reservations/calendar/$id/edit": typeof reservationsReservationsCalendarIdEditRoute
  "/reservations/calendar/$id/fulfillments": typeof reservationsReservationsCalendarIdFulfillmentsRoute
  "/service-providers/$id/new": typeof serviceProvidersServiceProvidersIdSheetNewRoute
  "/services/$id/edit": typeof servicesServicesSheetIdEditRoute
  "/tour-agencies/$id/new": typeof tourAgenciesTourAgenciesIdSheetNewRoute
  "/tours/$id/edit": typeof toursToursSheetIdEditRoute
  "/workers/$id/edit": typeof workersWorkersSheetIdEditRoute
  "/agencies/$id": typeof agenciesAgenciesSheetIdIndexRoute
  "/departments/$id": typeof departmentsDepartmentsSheetIdIndexRoute
  "/guides/$id": typeof guidesGuidesSheetIdIndexRoute
  "/hotels/$id": typeof hotelsHotelsSheetIdIndexRoute
  "/providers/$id": typeof providersProvidersSheetIdIndexRoute
  "/regions/$id": typeof regionsRegionsSheetIdIndexRoute
  "/reservations/calendar/$id": typeof reservationsReservationsCalendarIdIndexRoute
  "/reservations/calendar/new": typeof reservationsReservationsCalendarNewIndexRoute
  "/services/$id": typeof servicesServicesSheetIdIndexRoute
  "/tours/$id": typeof toursToursSheetIdIndexRoute
  "/workers/$id": typeof workersWorkersSheetIdIndexRoute
  "/payments/$id/balance/new": typeof paymentsPaymentsIdSheetBalanceNewRoute
  "/payments/$id/deposit/new": typeof paymentsPaymentsIdSheetDepositNewRoute
  "/service-providers/$id/edit/$spId": typeof serviceProvidersServiceProvidersIdSheetEditSpIdRoute
  "/tour-agencies/$id/edit/$taId": typeof tourAgenciesTourAgenciesIdSheetEditTaIdRoute
  "/reservations/$id/fulfillments/$fid/edit": typeof reservationsReservationsIdFulfillmentsFidEditIndexRoute
  "/reservations/$id/fulfillments/new/hotel": typeof reservationsReservationsIdFulfillmentsNewHotelIndexRoute
  "/reservations/$id/fulfillments/new/service": typeof reservationsReservationsIdFulfillmentsNewServiceIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/(agencies)/agencies": typeof agenciesAgenciesRouteWithChildren
  "/(departments)/departments": typeof departmentsDepartmentsRouteWithChildren
  "/(guides)/guides": typeof guidesGuidesRouteWithChildren
  "/(hotels)/hotels": typeof hotelsHotelsRouteWithChildren
  "/(operations)/operations": typeof operationsOperationsRoute
  "/(providers)/providers": typeof providersProvidersRouteWithChildren
  "/(regions)/regions": typeof regionsRegionsRouteWithChildren
  "/(services)/services": typeof servicesServicesRouteWithChildren
  "/(tours)/tours": typeof toursToursRouteWithChildren
  "/(workers)/workers": typeof workersWorkersRouteWithChildren
  "/(agencies)/agencies/_sheet": typeof agenciesAgenciesSheetRouteWithChildren
  "/(departments)/departments/_sheet": typeof departmentsDepartmentsSheetRouteWithChildren
  "/(guides)/guides/_sheet": typeof guidesGuidesSheetRouteWithChildren
  "/(hotel-rooms)/hotel-rooms/$id": typeof hotelRoomsHotelRoomsIdRouteWithChildren
  "/(hotels)/hotels/_sheet": typeof hotelsHotelsSheetRouteWithChildren
  "/(payment-adjustments)/payment-adjustments/$id": typeof paymentAdjustmentsPaymentAdjustmentsIdRouteWithChildren
  "/(payments)/payments/$id": typeof paymentsPaymentsIdRouteWithChildren
  "/(providers)/providers/_sheet": typeof providersProvidersSheetRouteWithChildren
  "/(regions)/regions/_sheet": typeof regionsRegionsSheetRouteWithChildren
  "/(reservations)/reservations/new": typeof reservationsReservationsNewRoute
  "/(service-providers)/service-providers/$id": typeof serviceProvidersServiceProvidersIdRouteWithChildren
  "/(services)/services/_sheet": typeof servicesServicesSheetRouteWithChildren
  "/(tour-agencies)/tour-agencies/$id": typeof tourAgenciesTourAgenciesIdRouteWithChildren
  "/(tour-days)/tour-days/$id": typeof tourDaysTourDaysIdRoute
  "/(tours)/tours/_sheet": typeof toursToursSheetRouteWithChildren
  "/(workers)/workers/_sheet": typeof workersWorkersSheetRouteWithChildren
  "/(reservations)/reservations/": typeof reservationsReservationsIndexRoute
  "/(agencies)/agencies/_sheet/new": typeof agenciesAgenciesSheetNewRoute
  "/(departments)/departments/_sheet/new": typeof departmentsDepartmentsSheetNewRoute
  "/(guides)/guides/_sheet/new": typeof guidesGuidesSheetNewRoute
  "/(hotel-rooms)/hotel-rooms/$id/_sheet": typeof hotelRoomsHotelRoomsIdSheetRouteWithChildren
  "/(hotels)/hotels/_sheet/new": typeof hotelsHotelsSheetNewRoute
  "/(payment-adjustments)/payment-adjustments/$id/_sheet": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetRouteWithChildren
  "/(payments)/payments/$id/_sheet": typeof paymentsPaymentsIdSheetRouteWithChildren
  "/(providers)/providers/_sheet/new": typeof providersProvidersSheetNewRoute
  "/(regions)/regions/_sheet/new": typeof regionsRegionsSheetNewRoute
  "/(reservations)/reservations/$id/edit": typeof reservationsReservationsIdEditRoute
  "/(reservations)/reservations/$id/fulfillments": typeof reservationsReservationsIdFulfillmentsRouteWithChildren
  "/(service-providers)/service-providers/$id/_sheet": typeof serviceProvidersServiceProvidersIdSheetRouteWithChildren
  "/(services)/services/_sheet/new": typeof servicesServicesSheetNewRoute
  "/(tour-agencies)/tour-agencies/$id/_sheet": typeof tourAgenciesTourAgenciesIdSheetRouteWithChildren
  "/(tours)/tours/_sheet/new": typeof toursToursSheetNewRoute
  "/(workers)/workers/_sheet/new": typeof workersWorkersSheetNewRoute
  "/(reservations)/reservations/$id/": typeof reservationsReservationsIdIndexRoute
  "/(reservations)/reservations/calendar/": typeof reservationsReservationsCalendarIndexRoute
  "/(agencies)/agencies/_sheet/$id/edit": typeof agenciesAgenciesSheetIdEditRoute
  "/(departments)/departments/_sheet/$id/edit": typeof departmentsDepartmentsSheetIdEditRoute
  "/(guides)/guides/_sheet/$id/edit": typeof guidesGuidesSheetIdEditRoute
  "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid": typeof hotelRoomsHotelRoomsIdSheetRidRoute
  "/(hotel-rooms)/hotel-rooms/$id/_sheet/new": typeof hotelRoomsHotelRoomsIdSheetNewRoute
  "/(hotels)/hotels/_sheet/$id/edit": typeof hotelsHotelsSheetIdEditRoute
  "/(payment-adjustments)/payment-adjustments/$id/_sheet/$pid": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetPidRoute
  "/(payment-adjustments)/payment-adjustments/$id/_sheet/new": typeof paymentAdjustmentsPaymentAdjustmentsIdSheetNewRoute
  "/(payments)/payments/$id/_sheet/$pid": typeof paymentsPaymentsIdSheetPidRoute
  "/(providers)/providers/_sheet/$id/edit": typeof providersProvidersSheetIdEditRoute
  "/(regions)/regions/_sheet/$id/edit": typeof regionsRegionsSheetIdEditRoute
  "/(reservations)/reservations/calendar/$id/edit": typeof reservationsReservationsCalendarIdEditRoute
  "/(reservations)/reservations/calendar/$id/fulfillments": typeof reservationsReservationsCalendarIdFulfillmentsRoute
  "/(service-providers)/service-providers/$id/_sheet/new": typeof serviceProvidersServiceProvidersIdSheetNewRoute
  "/(services)/services/_sheet/$id/edit": typeof servicesServicesSheetIdEditRoute
  "/(tour-agencies)/tour-agencies/$id/_sheet/new": typeof tourAgenciesTourAgenciesIdSheetNewRoute
  "/(tours)/tours/_sheet/$id/edit": typeof toursToursSheetIdEditRoute
  "/(workers)/workers/_sheet/$id/edit": typeof workersWorkersSheetIdEditRoute
  "/(agencies)/agencies/_sheet/$id/": typeof agenciesAgenciesSheetIdIndexRoute
  "/(departments)/departments/_sheet/$id/": typeof departmentsDepartmentsSheetIdIndexRoute
  "/(guides)/guides/_sheet/$id/": typeof guidesGuidesSheetIdIndexRoute
  "/(hotels)/hotels/_sheet/$id/": typeof hotelsHotelsSheetIdIndexRoute
  "/(providers)/providers/_sheet/$id/": typeof providersProvidersSheetIdIndexRoute
  "/(regions)/regions/_sheet/$id/": typeof regionsRegionsSheetIdIndexRoute
  "/(reservations)/reservations/calendar/$id/": typeof reservationsReservationsCalendarIdIndexRoute
  "/(reservations)/reservations/calendar/new/": typeof reservationsReservationsCalendarNewIndexRoute
  "/(services)/services/_sheet/$id/": typeof servicesServicesSheetIdIndexRoute
  "/(tours)/tours/_sheet/$id/": typeof toursToursSheetIdIndexRoute
  "/(workers)/workers/_sheet/$id/": typeof workersWorkersSheetIdIndexRoute
  "/(payments)/payments/$id/_sheet/balance/new": typeof paymentsPaymentsIdSheetBalanceNewRoute
  "/(payments)/payments/$id/_sheet/deposit/new": typeof paymentsPaymentsIdSheetDepositNewRoute
  "/(service-providers)/service-providers/$id/_sheet/edit/$spId": typeof serviceProvidersServiceProvidersIdSheetEditSpIdRoute
  "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId": typeof tourAgenciesTourAgenciesIdSheetEditTaIdRoute
  "/(reservations)/reservations/$id/fulfillments/$fid/edit/": typeof reservationsReservationsIdFulfillmentsFidEditIndexRoute
  "/(reservations)/reservations/$id/fulfillments/new/hotel/": typeof reservationsReservationsIdFulfillmentsNewHotelIndexRoute
  "/(reservations)/reservations/$id/fulfillments/new/service/": typeof reservationsReservationsIdFulfillmentsNewServiceIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/agencies"
    | "/departments"
    | "/guides"
    | "/hotels"
    | "/operations"
    | "/providers"
    | "/regions"
    | "/services"
    | "/tours"
    | "/workers"
    | "/hotel-rooms/$id"
    | "/payment-adjustments/$id"
    | "/payments/$id"
    | "/reservations/new"
    | "/service-providers/$id"
    | "/tour-agencies/$id"
    | "/tour-days/$id"
    | "/reservations"
    | "/agencies/new"
    | "/departments/new"
    | "/guides/new"
    | "/hotels/new"
    | "/providers/new"
    | "/regions/new"
    | "/reservations/$id/edit"
    | "/reservations/$id/fulfillments"
    | "/services/new"
    | "/tours/new"
    | "/workers/new"
    | "/reservations/$id"
    | "/reservations/calendar"
    | "/agencies/$id/edit"
    | "/departments/$id/edit"
    | "/guides/$id/edit"
    | "/hotel-rooms/$id/$rid"
    | "/hotel-rooms/$id/new"
    | "/hotels/$id/edit"
    | "/payment-adjustments/$id/$pid"
    | "/payment-adjustments/$id/new"
    | "/payments/$id/$pid"
    | "/providers/$id/edit"
    | "/regions/$id/edit"
    | "/reservations/calendar/$id/edit"
    | "/reservations/calendar/$id/fulfillments"
    | "/service-providers/$id/new"
    | "/services/$id/edit"
    | "/tour-agencies/$id/new"
    | "/tours/$id/edit"
    | "/workers/$id/edit"
    | "/agencies/$id"
    | "/departments/$id"
    | "/guides/$id"
    | "/hotels/$id"
    | "/providers/$id"
    | "/regions/$id"
    | "/reservations/calendar/$id"
    | "/reservations/calendar/new"
    | "/services/$id"
    | "/tours/$id"
    | "/workers/$id"
    | "/payments/$id/balance/new"
    | "/payments/$id/deposit/new"
    | "/service-providers/$id/edit/$spId"
    | "/tour-agencies/$id/edit/$taId"
    | "/reservations/$id/fulfillments/$fid/edit"
    | "/reservations/$id/fulfillments/new/hotel"
    | "/reservations/$id/fulfillments/new/service"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/agencies"
    | "/departments"
    | "/guides"
    | "/hotels"
    | "/operations"
    | "/providers"
    | "/regions"
    | "/services"
    | "/tours"
    | "/workers"
    | "/hotel-rooms/$id"
    | "/payment-adjustments/$id"
    | "/payments/$id"
    | "/reservations/new"
    | "/service-providers/$id"
    | "/tour-agencies/$id"
    | "/tour-days/$id"
    | "/reservations"
    | "/agencies/new"
    | "/departments/new"
    | "/guides/new"
    | "/hotels/new"
    | "/providers/new"
    | "/regions/new"
    | "/reservations/$id/edit"
    | "/reservations/$id/fulfillments"
    | "/services/new"
    | "/tours/new"
    | "/workers/new"
    | "/reservations/$id"
    | "/reservations/calendar"
    | "/agencies/$id/edit"
    | "/departments/$id/edit"
    | "/guides/$id/edit"
    | "/hotel-rooms/$id/$rid"
    | "/hotel-rooms/$id/new"
    | "/hotels/$id/edit"
    | "/payment-adjustments/$id/$pid"
    | "/payment-adjustments/$id/new"
    | "/payments/$id/$pid"
    | "/providers/$id/edit"
    | "/regions/$id/edit"
    | "/reservations/calendar/$id/edit"
    | "/reservations/calendar/$id/fulfillments"
    | "/service-providers/$id/new"
    | "/services/$id/edit"
    | "/tour-agencies/$id/new"
    | "/tours/$id/edit"
    | "/workers/$id/edit"
    | "/agencies/$id"
    | "/departments/$id"
    | "/guides/$id"
    | "/hotels/$id"
    | "/providers/$id"
    | "/regions/$id"
    | "/reservations/calendar/$id"
    | "/reservations/calendar/new"
    | "/services/$id"
    | "/tours/$id"
    | "/workers/$id"
    | "/payments/$id/balance/new"
    | "/payments/$id/deposit/new"
    | "/service-providers/$id/edit/$spId"
    | "/tour-agencies/$id/edit/$taId"
    | "/reservations/$id/fulfillments/$fid/edit"
    | "/reservations/$id/fulfillments/new/hotel"
    | "/reservations/$id/fulfillments/new/service"
  id:
    | "__root__"
    | "/"
    | "/(agencies)/agencies"
    | "/(departments)/departments"
    | "/(guides)/guides"
    | "/(hotels)/hotels"
    | "/(operations)/operations"
    | "/(providers)/providers"
    | "/(regions)/regions"
    | "/(services)/services"
    | "/(tours)/tours"
    | "/(workers)/workers"
    | "/(agencies)/agencies/_sheet"
    | "/(departments)/departments/_sheet"
    | "/(guides)/guides/_sheet"
    | "/(hotel-rooms)/hotel-rooms/$id"
    | "/(hotels)/hotels/_sheet"
    | "/(payment-adjustments)/payment-adjustments/$id"
    | "/(payments)/payments/$id"
    | "/(providers)/providers/_sheet"
    | "/(regions)/regions/_sheet"
    | "/(reservations)/reservations/new"
    | "/(service-providers)/service-providers/$id"
    | "/(services)/services/_sheet"
    | "/(tour-agencies)/tour-agencies/$id"
    | "/(tour-days)/tour-days/$id"
    | "/(tours)/tours/_sheet"
    | "/(workers)/workers/_sheet"
    | "/(reservations)/reservations/"
    | "/(agencies)/agencies/_sheet/new"
    | "/(departments)/departments/_sheet/new"
    | "/(guides)/guides/_sheet/new"
    | "/(hotel-rooms)/hotel-rooms/$id/_sheet"
    | "/(hotels)/hotels/_sheet/new"
    | "/(payment-adjustments)/payment-adjustments/$id/_sheet"
    | "/(payments)/payments/$id/_sheet"
    | "/(providers)/providers/_sheet/new"
    | "/(regions)/regions/_sheet/new"
    | "/(reservations)/reservations/$id/edit"
    | "/(reservations)/reservations/$id/fulfillments"
    | "/(service-providers)/service-providers/$id/_sheet"
    | "/(services)/services/_sheet/new"
    | "/(tour-agencies)/tour-agencies/$id/_sheet"
    | "/(tours)/tours/_sheet/new"
    | "/(workers)/workers/_sheet/new"
    | "/(reservations)/reservations/$id/"
    | "/(reservations)/reservations/calendar/"
    | "/(agencies)/agencies/_sheet/$id/edit"
    | "/(departments)/departments/_sheet/$id/edit"
    | "/(guides)/guides/_sheet/$id/edit"
    | "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid"
    | "/(hotel-rooms)/hotel-rooms/$id/_sheet/new"
    | "/(hotels)/hotels/_sheet/$id/edit"
    | "/(payment-adjustments)/payment-adjustments/$id/_sheet/$pid"
    | "/(payment-adjustments)/payment-adjustments/$id/_sheet/new"
    | "/(payments)/payments/$id/_sheet/$pid"
    | "/(providers)/providers/_sheet/$id/edit"
    | "/(regions)/regions/_sheet/$id/edit"
    | "/(reservations)/reservations/calendar/$id/edit"
    | "/(reservations)/reservations/calendar/$id/fulfillments"
    | "/(service-providers)/service-providers/$id/_sheet/new"
    | "/(services)/services/_sheet/$id/edit"
    | "/(tour-agencies)/tour-agencies/$id/_sheet/new"
    | "/(tours)/tours/_sheet/$id/edit"
    | "/(workers)/workers/_sheet/$id/edit"
    | "/(agencies)/agencies/_sheet/$id/"
    | "/(departments)/departments/_sheet/$id/"
    | "/(guides)/guides/_sheet/$id/"
    | "/(hotels)/hotels/_sheet/$id/"
    | "/(providers)/providers/_sheet/$id/"
    | "/(regions)/regions/_sheet/$id/"
    | "/(reservations)/reservations/calendar/$id/"
    | "/(reservations)/reservations/calendar/new/"
    | "/(services)/services/_sheet/$id/"
    | "/(tours)/tours/_sheet/$id/"
    | "/(workers)/workers/_sheet/$id/"
    | "/(payments)/payments/$id/_sheet/balance/new"
    | "/(payments)/payments/$id/_sheet/deposit/new"
    | "/(service-providers)/service-providers/$id/_sheet/edit/$spId"
    | "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId"
    | "/(reservations)/reservations/$id/fulfillments/$fid/edit/"
    | "/(reservations)/reservations/$id/fulfillments/new/hotel/"
    | "/(reservations)/reservations/$id/fulfillments/new/service/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  agenciesAgenciesRoute: typeof agenciesAgenciesRouteWithChildren
  departmentsDepartmentsRoute: typeof departmentsDepartmentsRouteWithChildren
  guidesGuidesRoute: typeof guidesGuidesRouteWithChildren
  hotelsHotelsRoute: typeof hotelsHotelsRouteWithChildren
  operationsOperationsRoute: typeof operationsOperationsRoute
  providersProvidersRoute: typeof providersProvidersRouteWithChildren
  regionsRegionsRoute: typeof regionsRegionsRouteWithChildren
  servicesServicesRoute: typeof servicesServicesRouteWithChildren
  toursToursRoute: typeof toursToursRouteWithChildren
  workersWorkersRoute: typeof workersWorkersRouteWithChildren
  hotelRoomsHotelRoomsIdRoute: typeof hotelRoomsHotelRoomsIdRouteWithChildren
  paymentAdjustmentsPaymentAdjustmentsIdRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdRouteWithChildren
  paymentsPaymentsIdRoute: typeof paymentsPaymentsIdRouteWithChildren
  reservationsReservationsNewRoute: typeof reservationsReservationsNewRoute
  serviceProvidersServiceProvidersIdRoute: typeof serviceProvidersServiceProvidersIdRouteWithChildren
  tourAgenciesTourAgenciesIdRoute: typeof tourAgenciesTourAgenciesIdRouteWithChildren
  tourDaysTourDaysIdRoute: typeof tourDaysTourDaysIdRoute
  reservationsReservationsIndexRoute: typeof reservationsReservationsIndexRoute
  reservationsReservationsIdEditRoute: typeof reservationsReservationsIdEditRoute
  reservationsReservationsIdFulfillmentsRoute: typeof reservationsReservationsIdFulfillmentsRouteWithChildren
  reservationsReservationsIdIndexRoute: typeof reservationsReservationsIdIndexRoute
  reservationsReservationsCalendarIndexRoute: typeof reservationsReservationsCalendarIndexRoute
  reservationsReservationsCalendarIdEditRoute: typeof reservationsReservationsCalendarIdEditRoute
  reservationsReservationsCalendarIdFulfillmentsRoute: typeof reservationsReservationsCalendarIdFulfillmentsRoute
  reservationsReservationsCalendarIdIndexRoute: typeof reservationsReservationsCalendarIdIndexRoute
  reservationsReservationsCalendarNewIndexRoute: typeof reservationsReservationsCalendarNewIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(workers)/workers": {
      id: "/(workers)/workers"
      path: "/workers"
      fullPath: "/workers"
      preLoaderRoute: typeof workersWorkersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(tours)/tours": {
      id: "/(tours)/tours"
      path: "/tours"
      fullPath: "/tours"
      preLoaderRoute: typeof toursToursRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(services)/services": {
      id: "/(services)/services"
      path: "/services"
      fullPath: "/services"
      preLoaderRoute: typeof servicesServicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(regions)/regions": {
      id: "/(regions)/regions"
      path: "/regions"
      fullPath: "/regions"
      preLoaderRoute: typeof regionsRegionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(providers)/providers": {
      id: "/(providers)/providers"
      path: "/providers"
      fullPath: "/providers"
      preLoaderRoute: typeof providersProvidersRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(operations)/operations": {
      id: "/(operations)/operations"
      path: "/operations"
      fullPath: "/operations"
      preLoaderRoute: typeof operationsOperationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(hotels)/hotels": {
      id: "/(hotels)/hotels"
      path: "/hotels"
      fullPath: "/hotels"
      preLoaderRoute: typeof hotelsHotelsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(guides)/guides": {
      id: "/(guides)/guides"
      path: "/guides"
      fullPath: "/guides"
      preLoaderRoute: typeof guidesGuidesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(departments)/departments": {
      id: "/(departments)/departments"
      path: "/departments"
      fullPath: "/departments"
      preLoaderRoute: typeof departmentsDepartmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(agencies)/agencies": {
      id: "/(agencies)/agencies"
      path: "/agencies"
      fullPath: "/agencies"
      preLoaderRoute: typeof agenciesAgenciesRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(reservations)/reservations/": {
      id: "/(reservations)/reservations/"
      path: "/reservations"
      fullPath: "/reservations"
      preLoaderRoute: typeof reservationsReservationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(workers)/workers/_sheet": {
      id: "/(workers)/workers/_sheet"
      path: ""
      fullPath: "/workers"
      preLoaderRoute: typeof workersWorkersSheetRouteImport
      parentRoute: typeof workersWorkersRoute
    }
    "/(tours)/tours/_sheet": {
      id: "/(tours)/tours/_sheet"
      path: ""
      fullPath: "/tours"
      preLoaderRoute: typeof toursToursSheetRouteImport
      parentRoute: typeof toursToursRoute
    }
    "/(tour-days)/tour-days/$id": {
      id: "/(tour-days)/tour-days/$id"
      path: "/tour-days/$id"
      fullPath: "/tour-days/$id"
      preLoaderRoute: typeof tourDaysTourDaysIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(tour-agencies)/tour-agencies/$id": {
      id: "/(tour-agencies)/tour-agencies/$id"
      path: "/tour-agencies/$id"
      fullPath: "/tour-agencies/$id"
      preLoaderRoute: typeof tourAgenciesTourAgenciesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(services)/services/_sheet": {
      id: "/(services)/services/_sheet"
      path: ""
      fullPath: "/services"
      preLoaderRoute: typeof servicesServicesSheetRouteImport
      parentRoute: typeof servicesServicesRoute
    }
    "/(service-providers)/service-providers/$id": {
      id: "/(service-providers)/service-providers/$id"
      path: "/service-providers/$id"
      fullPath: "/service-providers/$id"
      preLoaderRoute: typeof serviceProvidersServiceProvidersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(reservations)/reservations/new": {
      id: "/(reservations)/reservations/new"
      path: "/reservations/new"
      fullPath: "/reservations/new"
      preLoaderRoute: typeof reservationsReservationsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(regions)/regions/_sheet": {
      id: "/(regions)/regions/_sheet"
      path: ""
      fullPath: "/regions"
      preLoaderRoute: typeof regionsRegionsSheetRouteImport
      parentRoute: typeof regionsRegionsRoute
    }
    "/(providers)/providers/_sheet": {
      id: "/(providers)/providers/_sheet"
      path: ""
      fullPath: "/providers"
      preLoaderRoute: typeof providersProvidersSheetRouteImport
      parentRoute: typeof providersProvidersRoute
    }
    "/(payments)/payments/$id": {
      id: "/(payments)/payments/$id"
      path: "/payments/$id"
      fullPath: "/payments/$id"
      preLoaderRoute: typeof paymentsPaymentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(payment-adjustments)/payment-adjustments/$id": {
      id: "/(payment-adjustments)/payment-adjustments/$id"
      path: "/payment-adjustments/$id"
      fullPath: "/payment-adjustments/$id"
      preLoaderRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(hotels)/hotels/_sheet": {
      id: "/(hotels)/hotels/_sheet"
      path: ""
      fullPath: "/hotels"
      preLoaderRoute: typeof hotelsHotelsSheetRouteImport
      parentRoute: typeof hotelsHotelsRoute
    }
    "/(hotel-rooms)/hotel-rooms/$id": {
      id: "/(hotel-rooms)/hotel-rooms/$id"
      path: "/hotel-rooms/$id"
      fullPath: "/hotel-rooms/$id"
      preLoaderRoute: typeof hotelRoomsHotelRoomsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(guides)/guides/_sheet": {
      id: "/(guides)/guides/_sheet"
      path: ""
      fullPath: "/guides"
      preLoaderRoute: typeof guidesGuidesSheetRouteImport
      parentRoute: typeof guidesGuidesRoute
    }
    "/(departments)/departments/_sheet": {
      id: "/(departments)/departments/_sheet"
      path: ""
      fullPath: "/departments"
      preLoaderRoute: typeof departmentsDepartmentsSheetRouteImport
      parentRoute: typeof departmentsDepartmentsRoute
    }
    "/(agencies)/agencies/_sheet": {
      id: "/(agencies)/agencies/_sheet"
      path: ""
      fullPath: "/agencies"
      preLoaderRoute: typeof agenciesAgenciesSheetRouteImport
      parentRoute: typeof agenciesAgenciesRoute
    }
    "/(reservations)/reservations/calendar/": {
      id: "/(reservations)/reservations/calendar/"
      path: "/reservations/calendar"
      fullPath: "/reservations/calendar"
      preLoaderRoute: typeof reservationsReservationsCalendarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(reservations)/reservations/$id/": {
      id: "/(reservations)/reservations/$id/"
      path: "/reservations/$id"
      fullPath: "/reservations/$id"
      preLoaderRoute: typeof reservationsReservationsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(workers)/workers/_sheet/new": {
      id: "/(workers)/workers/_sheet/new"
      path: "/new"
      fullPath: "/workers/new"
      preLoaderRoute: typeof workersWorkersSheetNewRouteImport
      parentRoute: typeof workersWorkersSheetRoute
    }
    "/(tours)/tours/_sheet/new": {
      id: "/(tours)/tours/_sheet/new"
      path: "/new"
      fullPath: "/tours/new"
      preLoaderRoute: typeof toursToursSheetNewRouteImport
      parentRoute: typeof toursToursSheetRoute
    }
    "/(tour-agencies)/tour-agencies/$id/_sheet": {
      id: "/(tour-agencies)/tour-agencies/$id/_sheet"
      path: ""
      fullPath: "/tour-agencies/$id"
      preLoaderRoute: typeof tourAgenciesTourAgenciesIdSheetRouteImport
      parentRoute: typeof tourAgenciesTourAgenciesIdRoute
    }
    "/(services)/services/_sheet/new": {
      id: "/(services)/services/_sheet/new"
      path: "/new"
      fullPath: "/services/new"
      preLoaderRoute: typeof servicesServicesSheetNewRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    "/(service-providers)/service-providers/$id/_sheet": {
      id: "/(service-providers)/service-providers/$id/_sheet"
      path: ""
      fullPath: "/service-providers/$id"
      preLoaderRoute: typeof serviceProvidersServiceProvidersIdSheetRouteImport
      parentRoute: typeof serviceProvidersServiceProvidersIdRoute
    }
    "/(reservations)/reservations/$id/fulfillments": {
      id: "/(reservations)/reservations/$id/fulfillments"
      path: "/reservations/$id/fulfillments"
      fullPath: "/reservations/$id/fulfillments"
      preLoaderRoute: typeof reservationsReservationsIdFulfillmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(reservations)/reservations/$id/edit": {
      id: "/(reservations)/reservations/$id/edit"
      path: "/reservations/$id/edit"
      fullPath: "/reservations/$id/edit"
      preLoaderRoute: typeof reservationsReservationsIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(regions)/regions/_sheet/new": {
      id: "/(regions)/regions/_sheet/new"
      path: "/new"
      fullPath: "/regions/new"
      preLoaderRoute: typeof regionsRegionsSheetNewRouteImport
      parentRoute: typeof regionsRegionsSheetRoute
    }
    "/(providers)/providers/_sheet/new": {
      id: "/(providers)/providers/_sheet/new"
      path: "/new"
      fullPath: "/providers/new"
      preLoaderRoute: typeof providersProvidersSheetNewRouteImport
      parentRoute: typeof providersProvidersSheetRoute
    }
    "/(payments)/payments/$id/_sheet": {
      id: "/(payments)/payments/$id/_sheet"
      path: ""
      fullPath: "/payments/$id"
      preLoaderRoute: typeof paymentsPaymentsIdSheetRouteImport
      parentRoute: typeof paymentsPaymentsIdRoute
    }
    "/(payment-adjustments)/payment-adjustments/$id/_sheet": {
      id: "/(payment-adjustments)/payment-adjustments/$id/_sheet"
      path: ""
      fullPath: "/payment-adjustments/$id"
      preLoaderRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdSheetRouteImport
      parentRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdRoute
    }
    "/(hotels)/hotels/_sheet/new": {
      id: "/(hotels)/hotels/_sheet/new"
      path: "/new"
      fullPath: "/hotels/new"
      preLoaderRoute: typeof hotelsHotelsSheetNewRouteImport
      parentRoute: typeof hotelsHotelsSheetRoute
    }
    "/(hotel-rooms)/hotel-rooms/$id/_sheet": {
      id: "/(hotel-rooms)/hotel-rooms/$id/_sheet"
      path: ""
      fullPath: "/hotel-rooms/$id"
      preLoaderRoute: typeof hotelRoomsHotelRoomsIdSheetRouteImport
      parentRoute: typeof hotelRoomsHotelRoomsIdRoute
    }
    "/(guides)/guides/_sheet/new": {
      id: "/(guides)/guides/_sheet/new"
      path: "/new"
      fullPath: "/guides/new"
      preLoaderRoute: typeof guidesGuidesSheetNewRouteImport
      parentRoute: typeof guidesGuidesSheetRoute
    }
    "/(departments)/departments/_sheet/new": {
      id: "/(departments)/departments/_sheet/new"
      path: "/new"
      fullPath: "/departments/new"
      preLoaderRoute: typeof departmentsDepartmentsSheetNewRouteImport
      parentRoute: typeof departmentsDepartmentsSheetRoute
    }
    "/(agencies)/agencies/_sheet/new": {
      id: "/(agencies)/agencies/_sheet/new"
      path: "/new"
      fullPath: "/agencies/new"
      preLoaderRoute: typeof agenciesAgenciesSheetNewRouteImport
      parentRoute: typeof agenciesAgenciesSheetRoute
    }
    "/(workers)/workers/_sheet/$id/": {
      id: "/(workers)/workers/_sheet/$id/"
      path: "/$id"
      fullPath: "/workers/$id"
      preLoaderRoute: typeof workersWorkersSheetIdIndexRouteImport
      parentRoute: typeof workersWorkersSheetRoute
    }
    "/(tours)/tours/_sheet/$id/": {
      id: "/(tours)/tours/_sheet/$id/"
      path: "/$id"
      fullPath: "/tours/$id"
      preLoaderRoute: typeof toursToursSheetIdIndexRouteImport
      parentRoute: typeof toursToursSheetRoute
    }
    "/(services)/services/_sheet/$id/": {
      id: "/(services)/services/_sheet/$id/"
      path: "/$id"
      fullPath: "/services/$id"
      preLoaderRoute: typeof servicesServicesSheetIdIndexRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    "/(reservations)/reservations/calendar/new/": {
      id: "/(reservations)/reservations/calendar/new/"
      path: "/reservations/calendar/new"
      fullPath: "/reservations/calendar/new"
      preLoaderRoute: typeof reservationsReservationsCalendarNewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(reservations)/reservations/calendar/$id/": {
      id: "/(reservations)/reservations/calendar/$id/"
      path: "/reservations/calendar/$id"
      fullPath: "/reservations/calendar/$id"
      preLoaderRoute: typeof reservationsReservationsCalendarIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(regions)/regions/_sheet/$id/": {
      id: "/(regions)/regions/_sheet/$id/"
      path: "/$id"
      fullPath: "/regions/$id"
      preLoaderRoute: typeof regionsRegionsSheetIdIndexRouteImport
      parentRoute: typeof regionsRegionsSheetRoute
    }
    "/(providers)/providers/_sheet/$id/": {
      id: "/(providers)/providers/_sheet/$id/"
      path: "/$id"
      fullPath: "/providers/$id"
      preLoaderRoute: typeof providersProvidersSheetIdIndexRouteImport
      parentRoute: typeof providersProvidersSheetRoute
    }
    "/(hotels)/hotels/_sheet/$id/": {
      id: "/(hotels)/hotels/_sheet/$id/"
      path: "/$id"
      fullPath: "/hotels/$id"
      preLoaderRoute: typeof hotelsHotelsSheetIdIndexRouteImport
      parentRoute: typeof hotelsHotelsSheetRoute
    }
    "/(guides)/guides/_sheet/$id/": {
      id: "/(guides)/guides/_sheet/$id/"
      path: "/$id"
      fullPath: "/guides/$id"
      preLoaderRoute: typeof guidesGuidesSheetIdIndexRouteImport
      parentRoute: typeof guidesGuidesSheetRoute
    }
    "/(departments)/departments/_sheet/$id/": {
      id: "/(departments)/departments/_sheet/$id/"
      path: "/$id"
      fullPath: "/departments/$id"
      preLoaderRoute: typeof departmentsDepartmentsSheetIdIndexRouteImport
      parentRoute: typeof departmentsDepartmentsSheetRoute
    }
    "/(agencies)/agencies/_sheet/$id/": {
      id: "/(agencies)/agencies/_sheet/$id/"
      path: "/$id"
      fullPath: "/agencies/$id"
      preLoaderRoute: typeof agenciesAgenciesSheetIdIndexRouteImport
      parentRoute: typeof agenciesAgenciesSheetRoute
    }
    "/(workers)/workers/_sheet/$id/edit": {
      id: "/(workers)/workers/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/workers/$id/edit"
      preLoaderRoute: typeof workersWorkersSheetIdEditRouteImport
      parentRoute: typeof workersWorkersSheetRoute
    }
    "/(tours)/tours/_sheet/$id/edit": {
      id: "/(tours)/tours/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/tours/$id/edit"
      preLoaderRoute: typeof toursToursSheetIdEditRouteImport
      parentRoute: typeof toursToursSheetRoute
    }
    "/(tour-agencies)/tour-agencies/$id/_sheet/new": {
      id: "/(tour-agencies)/tour-agencies/$id/_sheet/new"
      path: "/new"
      fullPath: "/tour-agencies/$id/new"
      preLoaderRoute: typeof tourAgenciesTourAgenciesIdSheetNewRouteImport
      parentRoute: typeof tourAgenciesTourAgenciesIdSheetRoute
    }
    "/(services)/services/_sheet/$id/edit": {
      id: "/(services)/services/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/services/$id/edit"
      preLoaderRoute: typeof servicesServicesSheetIdEditRouteImport
      parentRoute: typeof servicesServicesSheetRoute
    }
    "/(service-providers)/service-providers/$id/_sheet/new": {
      id: "/(service-providers)/service-providers/$id/_sheet/new"
      path: "/new"
      fullPath: "/service-providers/$id/new"
      preLoaderRoute: typeof serviceProvidersServiceProvidersIdSheetNewRouteImport
      parentRoute: typeof serviceProvidersServiceProvidersIdSheetRoute
    }
    "/(reservations)/reservations/calendar/$id/fulfillments": {
      id: "/(reservations)/reservations/calendar/$id/fulfillments"
      path: "/reservations/calendar/$id/fulfillments"
      fullPath: "/reservations/calendar/$id/fulfillments"
      preLoaderRoute: typeof reservationsReservationsCalendarIdFulfillmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(reservations)/reservations/calendar/$id/edit": {
      id: "/(reservations)/reservations/calendar/$id/edit"
      path: "/reservations/calendar/$id/edit"
      fullPath: "/reservations/calendar/$id/edit"
      preLoaderRoute: typeof reservationsReservationsCalendarIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/(regions)/regions/_sheet/$id/edit": {
      id: "/(regions)/regions/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/regions/$id/edit"
      preLoaderRoute: typeof regionsRegionsSheetIdEditRouteImport
      parentRoute: typeof regionsRegionsSheetRoute
    }
    "/(providers)/providers/_sheet/$id/edit": {
      id: "/(providers)/providers/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/providers/$id/edit"
      preLoaderRoute: typeof providersProvidersSheetIdEditRouteImport
      parentRoute: typeof providersProvidersSheetRoute
    }
    "/(payments)/payments/$id/_sheet/$pid": {
      id: "/(payments)/payments/$id/_sheet/$pid"
      path: "/$pid"
      fullPath: "/payments/$id/$pid"
      preLoaderRoute: typeof paymentsPaymentsIdSheetPidRouteImport
      parentRoute: typeof paymentsPaymentsIdSheetRoute
    }
    "/(payment-adjustments)/payment-adjustments/$id/_sheet/new": {
      id: "/(payment-adjustments)/payment-adjustments/$id/_sheet/new"
      path: "/new"
      fullPath: "/payment-adjustments/$id/new"
      preLoaderRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdSheetNewRouteImport
      parentRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdSheetRoute
    }
    "/(payment-adjustments)/payment-adjustments/$id/_sheet/$pid": {
      id: "/(payment-adjustments)/payment-adjustments/$id/_sheet/$pid"
      path: "/$pid"
      fullPath: "/payment-adjustments/$id/$pid"
      preLoaderRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdSheetPidRouteImport
      parentRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdSheetRoute
    }
    "/(hotels)/hotels/_sheet/$id/edit": {
      id: "/(hotels)/hotels/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/hotels/$id/edit"
      preLoaderRoute: typeof hotelsHotelsSheetIdEditRouteImport
      parentRoute: typeof hotelsHotelsSheetRoute
    }
    "/(hotel-rooms)/hotel-rooms/$id/_sheet/new": {
      id: "/(hotel-rooms)/hotel-rooms/$id/_sheet/new"
      path: "/new"
      fullPath: "/hotel-rooms/$id/new"
      preLoaderRoute: typeof hotelRoomsHotelRoomsIdSheetNewRouteImport
      parentRoute: typeof hotelRoomsHotelRoomsIdSheetRoute
    }
    "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid": {
      id: "/(hotel-rooms)/hotel-rooms/$id/_sheet/$rid"
      path: "/$rid"
      fullPath: "/hotel-rooms/$id/$rid"
      preLoaderRoute: typeof hotelRoomsHotelRoomsIdSheetRidRouteImport
      parentRoute: typeof hotelRoomsHotelRoomsIdSheetRoute
    }
    "/(guides)/guides/_sheet/$id/edit": {
      id: "/(guides)/guides/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/guides/$id/edit"
      preLoaderRoute: typeof guidesGuidesSheetIdEditRouteImport
      parentRoute: typeof guidesGuidesSheetRoute
    }
    "/(departments)/departments/_sheet/$id/edit": {
      id: "/(departments)/departments/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/departments/$id/edit"
      preLoaderRoute: typeof departmentsDepartmentsSheetIdEditRouteImport
      parentRoute: typeof departmentsDepartmentsSheetRoute
    }
    "/(agencies)/agencies/_sheet/$id/edit": {
      id: "/(agencies)/agencies/_sheet/$id/edit"
      path: "/$id/edit"
      fullPath: "/agencies/$id/edit"
      preLoaderRoute: typeof agenciesAgenciesSheetIdEditRouteImport
      parentRoute: typeof agenciesAgenciesSheetRoute
    }
    "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId": {
      id: "/(tour-agencies)/tour-agencies/$id/_sheet/edit/$taId"
      path: "/edit/$taId"
      fullPath: "/tour-agencies/$id/edit/$taId"
      preLoaderRoute: typeof tourAgenciesTourAgenciesIdSheetEditTaIdRouteImport
      parentRoute: typeof tourAgenciesTourAgenciesIdSheetRoute
    }
    "/(service-providers)/service-providers/$id/_sheet/edit/$spId": {
      id: "/(service-providers)/service-providers/$id/_sheet/edit/$spId"
      path: "/edit/$spId"
      fullPath: "/service-providers/$id/edit/$spId"
      preLoaderRoute: typeof serviceProvidersServiceProvidersIdSheetEditSpIdRouteImport
      parentRoute: typeof serviceProvidersServiceProvidersIdSheetRoute
    }
    "/(payments)/payments/$id/_sheet/deposit/new": {
      id: "/(payments)/payments/$id/_sheet/deposit/new"
      path: "/deposit/new"
      fullPath: "/payments/$id/deposit/new"
      preLoaderRoute: typeof paymentsPaymentsIdSheetDepositNewRouteImport
      parentRoute: typeof paymentsPaymentsIdSheetRoute
    }
    "/(payments)/payments/$id/_sheet/balance/new": {
      id: "/(payments)/payments/$id/_sheet/balance/new"
      path: "/balance/new"
      fullPath: "/payments/$id/balance/new"
      preLoaderRoute: typeof paymentsPaymentsIdSheetBalanceNewRouteImport
      parentRoute: typeof paymentsPaymentsIdSheetRoute
    }
    "/(reservations)/reservations/$id/fulfillments/new/service/": {
      id: "/(reservations)/reservations/$id/fulfillments/new/service/"
      path: "/new/service"
      fullPath: "/reservations/$id/fulfillments/new/service"
      preLoaderRoute: typeof reservationsReservationsIdFulfillmentsNewServiceIndexRouteImport
      parentRoute: typeof reservationsReservationsIdFulfillmentsRoute
    }
    "/(reservations)/reservations/$id/fulfillments/new/hotel/": {
      id: "/(reservations)/reservations/$id/fulfillments/new/hotel/"
      path: "/new/hotel"
      fullPath: "/reservations/$id/fulfillments/new/hotel"
      preLoaderRoute: typeof reservationsReservationsIdFulfillmentsNewHotelIndexRouteImport
      parentRoute: typeof reservationsReservationsIdFulfillmentsRoute
    }
    "/(reservations)/reservations/$id/fulfillments/$fid/edit/": {
      id: "/(reservations)/reservations/$id/fulfillments/$fid/edit/"
      path: "/$fid/edit"
      fullPath: "/reservations/$id/fulfillments/$fid/edit"
      preLoaderRoute: typeof reservationsReservationsIdFulfillmentsFidEditIndexRouteImport
      parentRoute: typeof reservationsReservationsIdFulfillmentsRoute
    }
  }
}

interface agenciesAgenciesSheetRouteChildren {
  agenciesAgenciesSheetNewRoute: typeof agenciesAgenciesSheetNewRoute
  agenciesAgenciesSheetIdEditRoute: typeof agenciesAgenciesSheetIdEditRoute
  agenciesAgenciesSheetIdIndexRoute: typeof agenciesAgenciesSheetIdIndexRoute
}

const agenciesAgenciesSheetRouteChildren: agenciesAgenciesSheetRouteChildren = {
  agenciesAgenciesSheetNewRoute: agenciesAgenciesSheetNewRoute,
  agenciesAgenciesSheetIdEditRoute: agenciesAgenciesSheetIdEditRoute,
  agenciesAgenciesSheetIdIndexRoute: agenciesAgenciesSheetIdIndexRoute,
}

const agenciesAgenciesSheetRouteWithChildren =
  agenciesAgenciesSheetRoute._addFileChildren(
    agenciesAgenciesSheetRouteChildren,
  )

interface agenciesAgenciesRouteChildren {
  agenciesAgenciesSheetRoute: typeof agenciesAgenciesSheetRouteWithChildren
}

const agenciesAgenciesRouteChildren: agenciesAgenciesRouteChildren = {
  agenciesAgenciesSheetRoute: agenciesAgenciesSheetRouteWithChildren,
}

const agenciesAgenciesRouteWithChildren =
  agenciesAgenciesRoute._addFileChildren(agenciesAgenciesRouteChildren)

interface departmentsDepartmentsSheetRouteChildren {
  departmentsDepartmentsSheetNewRoute: typeof departmentsDepartmentsSheetNewRoute
  departmentsDepartmentsSheetIdEditRoute: typeof departmentsDepartmentsSheetIdEditRoute
  departmentsDepartmentsSheetIdIndexRoute: typeof departmentsDepartmentsSheetIdIndexRoute
}

const departmentsDepartmentsSheetRouteChildren: departmentsDepartmentsSheetRouteChildren =
  {
    departmentsDepartmentsSheetNewRoute: departmentsDepartmentsSheetNewRoute,
    departmentsDepartmentsSheetIdEditRoute:
      departmentsDepartmentsSheetIdEditRoute,
    departmentsDepartmentsSheetIdIndexRoute:
      departmentsDepartmentsSheetIdIndexRoute,
  }

const departmentsDepartmentsSheetRouteWithChildren =
  departmentsDepartmentsSheetRoute._addFileChildren(
    departmentsDepartmentsSheetRouteChildren,
  )

interface departmentsDepartmentsRouteChildren {
  departmentsDepartmentsSheetRoute: typeof departmentsDepartmentsSheetRouteWithChildren
}

const departmentsDepartmentsRouteChildren: departmentsDepartmentsRouteChildren =
  {
    departmentsDepartmentsSheetRoute:
      departmentsDepartmentsSheetRouteWithChildren,
  }

const departmentsDepartmentsRouteWithChildren =
  departmentsDepartmentsRoute._addFileChildren(
    departmentsDepartmentsRouteChildren,
  )

interface guidesGuidesSheetRouteChildren {
  guidesGuidesSheetNewRoute: typeof guidesGuidesSheetNewRoute
  guidesGuidesSheetIdEditRoute: typeof guidesGuidesSheetIdEditRoute
  guidesGuidesSheetIdIndexRoute: typeof guidesGuidesSheetIdIndexRoute
}

const guidesGuidesSheetRouteChildren: guidesGuidesSheetRouteChildren = {
  guidesGuidesSheetNewRoute: guidesGuidesSheetNewRoute,
  guidesGuidesSheetIdEditRoute: guidesGuidesSheetIdEditRoute,
  guidesGuidesSheetIdIndexRoute: guidesGuidesSheetIdIndexRoute,
}

const guidesGuidesSheetRouteWithChildren =
  guidesGuidesSheetRoute._addFileChildren(guidesGuidesSheetRouteChildren)

interface guidesGuidesRouteChildren {
  guidesGuidesSheetRoute: typeof guidesGuidesSheetRouteWithChildren
}

const guidesGuidesRouteChildren: guidesGuidesRouteChildren = {
  guidesGuidesSheetRoute: guidesGuidesSheetRouteWithChildren,
}

const guidesGuidesRouteWithChildren = guidesGuidesRoute._addFileChildren(
  guidesGuidesRouteChildren,
)

interface hotelsHotelsSheetRouteChildren {
  hotelsHotelsSheetNewRoute: typeof hotelsHotelsSheetNewRoute
  hotelsHotelsSheetIdEditRoute: typeof hotelsHotelsSheetIdEditRoute
  hotelsHotelsSheetIdIndexRoute: typeof hotelsHotelsSheetIdIndexRoute
}

const hotelsHotelsSheetRouteChildren: hotelsHotelsSheetRouteChildren = {
  hotelsHotelsSheetNewRoute: hotelsHotelsSheetNewRoute,
  hotelsHotelsSheetIdEditRoute: hotelsHotelsSheetIdEditRoute,
  hotelsHotelsSheetIdIndexRoute: hotelsHotelsSheetIdIndexRoute,
}

const hotelsHotelsSheetRouteWithChildren =
  hotelsHotelsSheetRoute._addFileChildren(hotelsHotelsSheetRouteChildren)

interface hotelsHotelsRouteChildren {
  hotelsHotelsSheetRoute: typeof hotelsHotelsSheetRouteWithChildren
}

const hotelsHotelsRouteChildren: hotelsHotelsRouteChildren = {
  hotelsHotelsSheetRoute: hotelsHotelsSheetRouteWithChildren,
}

const hotelsHotelsRouteWithChildren = hotelsHotelsRoute._addFileChildren(
  hotelsHotelsRouteChildren,
)

interface providersProvidersSheetRouteChildren {
  providersProvidersSheetNewRoute: typeof providersProvidersSheetNewRoute
  providersProvidersSheetIdEditRoute: typeof providersProvidersSheetIdEditRoute
  providersProvidersSheetIdIndexRoute: typeof providersProvidersSheetIdIndexRoute
}

const providersProvidersSheetRouteChildren: providersProvidersSheetRouteChildren =
  {
    providersProvidersSheetNewRoute: providersProvidersSheetNewRoute,
    providersProvidersSheetIdEditRoute: providersProvidersSheetIdEditRoute,
    providersProvidersSheetIdIndexRoute: providersProvidersSheetIdIndexRoute,
  }

const providersProvidersSheetRouteWithChildren =
  providersProvidersSheetRoute._addFileChildren(
    providersProvidersSheetRouteChildren,
  )

interface providersProvidersRouteChildren {
  providersProvidersSheetRoute: typeof providersProvidersSheetRouteWithChildren
}

const providersProvidersRouteChildren: providersProvidersRouteChildren = {
  providersProvidersSheetRoute: providersProvidersSheetRouteWithChildren,
}

const providersProvidersRouteWithChildren =
  providersProvidersRoute._addFileChildren(providersProvidersRouteChildren)

interface regionsRegionsSheetRouteChildren {
  regionsRegionsSheetNewRoute: typeof regionsRegionsSheetNewRoute
  regionsRegionsSheetIdEditRoute: typeof regionsRegionsSheetIdEditRoute
  regionsRegionsSheetIdIndexRoute: typeof regionsRegionsSheetIdIndexRoute
}

const regionsRegionsSheetRouteChildren: regionsRegionsSheetRouteChildren = {
  regionsRegionsSheetNewRoute: regionsRegionsSheetNewRoute,
  regionsRegionsSheetIdEditRoute: regionsRegionsSheetIdEditRoute,
  regionsRegionsSheetIdIndexRoute: regionsRegionsSheetIdIndexRoute,
}

const regionsRegionsSheetRouteWithChildren =
  regionsRegionsSheetRoute._addFileChildren(regionsRegionsSheetRouteChildren)

interface regionsRegionsRouteChildren {
  regionsRegionsSheetRoute: typeof regionsRegionsSheetRouteWithChildren
}

const regionsRegionsRouteChildren: regionsRegionsRouteChildren = {
  regionsRegionsSheetRoute: regionsRegionsSheetRouteWithChildren,
}

const regionsRegionsRouteWithChildren = regionsRegionsRoute._addFileChildren(
  regionsRegionsRouteChildren,
)

interface servicesServicesSheetRouteChildren {
  servicesServicesSheetNewRoute: typeof servicesServicesSheetNewRoute
  servicesServicesSheetIdEditRoute: typeof servicesServicesSheetIdEditRoute
  servicesServicesSheetIdIndexRoute: typeof servicesServicesSheetIdIndexRoute
}

const servicesServicesSheetRouteChildren: servicesServicesSheetRouteChildren = {
  servicesServicesSheetNewRoute: servicesServicesSheetNewRoute,
  servicesServicesSheetIdEditRoute: servicesServicesSheetIdEditRoute,
  servicesServicesSheetIdIndexRoute: servicesServicesSheetIdIndexRoute,
}

const servicesServicesSheetRouteWithChildren =
  servicesServicesSheetRoute._addFileChildren(
    servicesServicesSheetRouteChildren,
  )

interface servicesServicesRouteChildren {
  servicesServicesSheetRoute: typeof servicesServicesSheetRouteWithChildren
}

const servicesServicesRouteChildren: servicesServicesRouteChildren = {
  servicesServicesSheetRoute: servicesServicesSheetRouteWithChildren,
}

const servicesServicesRouteWithChildren =
  servicesServicesRoute._addFileChildren(servicesServicesRouteChildren)

interface toursToursSheetRouteChildren {
  toursToursSheetNewRoute: typeof toursToursSheetNewRoute
  toursToursSheetIdEditRoute: typeof toursToursSheetIdEditRoute
  toursToursSheetIdIndexRoute: typeof toursToursSheetIdIndexRoute
}

const toursToursSheetRouteChildren: toursToursSheetRouteChildren = {
  toursToursSheetNewRoute: toursToursSheetNewRoute,
  toursToursSheetIdEditRoute: toursToursSheetIdEditRoute,
  toursToursSheetIdIndexRoute: toursToursSheetIdIndexRoute,
}

const toursToursSheetRouteWithChildren = toursToursSheetRoute._addFileChildren(
  toursToursSheetRouteChildren,
)

interface toursToursRouteChildren {
  toursToursSheetRoute: typeof toursToursSheetRouteWithChildren
}

const toursToursRouteChildren: toursToursRouteChildren = {
  toursToursSheetRoute: toursToursSheetRouteWithChildren,
}

const toursToursRouteWithChildren = toursToursRoute._addFileChildren(
  toursToursRouteChildren,
)

interface workersWorkersSheetRouteChildren {
  workersWorkersSheetNewRoute: typeof workersWorkersSheetNewRoute
  workersWorkersSheetIdEditRoute: typeof workersWorkersSheetIdEditRoute
  workersWorkersSheetIdIndexRoute: typeof workersWorkersSheetIdIndexRoute
}

const workersWorkersSheetRouteChildren: workersWorkersSheetRouteChildren = {
  workersWorkersSheetNewRoute: workersWorkersSheetNewRoute,
  workersWorkersSheetIdEditRoute: workersWorkersSheetIdEditRoute,
  workersWorkersSheetIdIndexRoute: workersWorkersSheetIdIndexRoute,
}

const workersWorkersSheetRouteWithChildren =
  workersWorkersSheetRoute._addFileChildren(workersWorkersSheetRouteChildren)

interface workersWorkersRouteChildren {
  workersWorkersSheetRoute: typeof workersWorkersSheetRouteWithChildren
}

const workersWorkersRouteChildren: workersWorkersRouteChildren = {
  workersWorkersSheetRoute: workersWorkersSheetRouteWithChildren,
}

const workersWorkersRouteWithChildren = workersWorkersRoute._addFileChildren(
  workersWorkersRouteChildren,
)

interface hotelRoomsHotelRoomsIdSheetRouteChildren {
  hotelRoomsHotelRoomsIdSheetRidRoute: typeof hotelRoomsHotelRoomsIdSheetRidRoute
  hotelRoomsHotelRoomsIdSheetNewRoute: typeof hotelRoomsHotelRoomsIdSheetNewRoute
}

const hotelRoomsHotelRoomsIdSheetRouteChildren: hotelRoomsHotelRoomsIdSheetRouteChildren =
  {
    hotelRoomsHotelRoomsIdSheetRidRoute: hotelRoomsHotelRoomsIdSheetRidRoute,
    hotelRoomsHotelRoomsIdSheetNewRoute: hotelRoomsHotelRoomsIdSheetNewRoute,
  }

const hotelRoomsHotelRoomsIdSheetRouteWithChildren =
  hotelRoomsHotelRoomsIdSheetRoute._addFileChildren(
    hotelRoomsHotelRoomsIdSheetRouteChildren,
  )

interface hotelRoomsHotelRoomsIdRouteChildren {
  hotelRoomsHotelRoomsIdSheetRoute: typeof hotelRoomsHotelRoomsIdSheetRouteWithChildren
}

const hotelRoomsHotelRoomsIdRouteChildren: hotelRoomsHotelRoomsIdRouteChildren =
  {
    hotelRoomsHotelRoomsIdSheetRoute:
      hotelRoomsHotelRoomsIdSheetRouteWithChildren,
  }

const hotelRoomsHotelRoomsIdRouteWithChildren =
  hotelRoomsHotelRoomsIdRoute._addFileChildren(
    hotelRoomsHotelRoomsIdRouteChildren,
  )

interface paymentAdjustmentsPaymentAdjustmentsIdSheetRouteChildren {
  paymentAdjustmentsPaymentAdjustmentsIdSheetPidRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdSheetPidRoute
  paymentAdjustmentsPaymentAdjustmentsIdSheetNewRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdSheetNewRoute
}

const paymentAdjustmentsPaymentAdjustmentsIdSheetRouteChildren: paymentAdjustmentsPaymentAdjustmentsIdSheetRouteChildren =
  {
    paymentAdjustmentsPaymentAdjustmentsIdSheetPidRoute:
      paymentAdjustmentsPaymentAdjustmentsIdSheetPidRoute,
    paymentAdjustmentsPaymentAdjustmentsIdSheetNewRoute:
      paymentAdjustmentsPaymentAdjustmentsIdSheetNewRoute,
  }

const paymentAdjustmentsPaymentAdjustmentsIdSheetRouteWithChildren =
  paymentAdjustmentsPaymentAdjustmentsIdSheetRoute._addFileChildren(
    paymentAdjustmentsPaymentAdjustmentsIdSheetRouteChildren,
  )

interface paymentAdjustmentsPaymentAdjustmentsIdRouteChildren {
  paymentAdjustmentsPaymentAdjustmentsIdSheetRoute: typeof paymentAdjustmentsPaymentAdjustmentsIdSheetRouteWithChildren
}

const paymentAdjustmentsPaymentAdjustmentsIdRouteChildren: paymentAdjustmentsPaymentAdjustmentsIdRouteChildren =
  {
    paymentAdjustmentsPaymentAdjustmentsIdSheetRoute:
      paymentAdjustmentsPaymentAdjustmentsIdSheetRouteWithChildren,
  }

const paymentAdjustmentsPaymentAdjustmentsIdRouteWithChildren =
  paymentAdjustmentsPaymentAdjustmentsIdRoute._addFileChildren(
    paymentAdjustmentsPaymentAdjustmentsIdRouteChildren,
  )

interface paymentsPaymentsIdSheetRouteChildren {
  paymentsPaymentsIdSheetPidRoute: typeof paymentsPaymentsIdSheetPidRoute
  paymentsPaymentsIdSheetBalanceNewRoute: typeof paymentsPaymentsIdSheetBalanceNewRoute
  paymentsPaymentsIdSheetDepositNewRoute: typeof paymentsPaymentsIdSheetDepositNewRoute
}

const paymentsPaymentsIdSheetRouteChildren: paymentsPaymentsIdSheetRouteChildren =
  {
    paymentsPaymentsIdSheetPidRoute: paymentsPaymentsIdSheetPidRoute,
    paymentsPaymentsIdSheetBalanceNewRoute:
      paymentsPaymentsIdSheetBalanceNewRoute,
    paymentsPaymentsIdSheetDepositNewRoute:
      paymentsPaymentsIdSheetDepositNewRoute,
  }

const paymentsPaymentsIdSheetRouteWithChildren =
  paymentsPaymentsIdSheetRoute._addFileChildren(
    paymentsPaymentsIdSheetRouteChildren,
  )

interface paymentsPaymentsIdRouteChildren {
  paymentsPaymentsIdSheetRoute: typeof paymentsPaymentsIdSheetRouteWithChildren
}

const paymentsPaymentsIdRouteChildren: paymentsPaymentsIdRouteChildren = {
  paymentsPaymentsIdSheetRoute: paymentsPaymentsIdSheetRouteWithChildren,
}

const paymentsPaymentsIdRouteWithChildren =
  paymentsPaymentsIdRoute._addFileChildren(paymentsPaymentsIdRouteChildren)

interface serviceProvidersServiceProvidersIdSheetRouteChildren {
  serviceProvidersServiceProvidersIdSheetNewRoute: typeof serviceProvidersServiceProvidersIdSheetNewRoute
  serviceProvidersServiceProvidersIdSheetEditSpIdRoute: typeof serviceProvidersServiceProvidersIdSheetEditSpIdRoute
}

const serviceProvidersServiceProvidersIdSheetRouteChildren: serviceProvidersServiceProvidersIdSheetRouteChildren =
  {
    serviceProvidersServiceProvidersIdSheetNewRoute:
      serviceProvidersServiceProvidersIdSheetNewRoute,
    serviceProvidersServiceProvidersIdSheetEditSpIdRoute:
      serviceProvidersServiceProvidersIdSheetEditSpIdRoute,
  }

const serviceProvidersServiceProvidersIdSheetRouteWithChildren =
  serviceProvidersServiceProvidersIdSheetRoute._addFileChildren(
    serviceProvidersServiceProvidersIdSheetRouteChildren,
  )

interface serviceProvidersServiceProvidersIdRouteChildren {
  serviceProvidersServiceProvidersIdSheetRoute: typeof serviceProvidersServiceProvidersIdSheetRouteWithChildren
}

const serviceProvidersServiceProvidersIdRouteChildren: serviceProvidersServiceProvidersIdRouteChildren =
  {
    serviceProvidersServiceProvidersIdSheetRoute:
      serviceProvidersServiceProvidersIdSheetRouteWithChildren,
  }

const serviceProvidersServiceProvidersIdRouteWithChildren =
  serviceProvidersServiceProvidersIdRoute._addFileChildren(
    serviceProvidersServiceProvidersIdRouteChildren,
  )

interface tourAgenciesTourAgenciesIdSheetRouteChildren {
  tourAgenciesTourAgenciesIdSheetNewRoute: typeof tourAgenciesTourAgenciesIdSheetNewRoute
  tourAgenciesTourAgenciesIdSheetEditTaIdRoute: typeof tourAgenciesTourAgenciesIdSheetEditTaIdRoute
}

const tourAgenciesTourAgenciesIdSheetRouteChildren: tourAgenciesTourAgenciesIdSheetRouteChildren =
  {
    tourAgenciesTourAgenciesIdSheetNewRoute:
      tourAgenciesTourAgenciesIdSheetNewRoute,
    tourAgenciesTourAgenciesIdSheetEditTaIdRoute:
      tourAgenciesTourAgenciesIdSheetEditTaIdRoute,
  }

const tourAgenciesTourAgenciesIdSheetRouteWithChildren =
  tourAgenciesTourAgenciesIdSheetRoute._addFileChildren(
    tourAgenciesTourAgenciesIdSheetRouteChildren,
  )

interface tourAgenciesTourAgenciesIdRouteChildren {
  tourAgenciesTourAgenciesIdSheetRoute: typeof tourAgenciesTourAgenciesIdSheetRouteWithChildren
}

const tourAgenciesTourAgenciesIdRouteChildren: tourAgenciesTourAgenciesIdRouteChildren =
  {
    tourAgenciesTourAgenciesIdSheetRoute:
      tourAgenciesTourAgenciesIdSheetRouteWithChildren,
  }

const tourAgenciesTourAgenciesIdRouteWithChildren =
  tourAgenciesTourAgenciesIdRoute._addFileChildren(
    tourAgenciesTourAgenciesIdRouteChildren,
  )

interface reservationsReservationsIdFulfillmentsRouteChildren {
  reservationsReservationsIdFulfillmentsFidEditIndexRoute: typeof reservationsReservationsIdFulfillmentsFidEditIndexRoute
  reservationsReservationsIdFulfillmentsNewHotelIndexRoute: typeof reservationsReservationsIdFulfillmentsNewHotelIndexRoute
  reservationsReservationsIdFulfillmentsNewServiceIndexRoute: typeof reservationsReservationsIdFulfillmentsNewServiceIndexRoute
}

const reservationsReservationsIdFulfillmentsRouteChildren: reservationsReservationsIdFulfillmentsRouteChildren =
  {
    reservationsReservationsIdFulfillmentsFidEditIndexRoute:
      reservationsReservationsIdFulfillmentsFidEditIndexRoute,
    reservationsReservationsIdFulfillmentsNewHotelIndexRoute:
      reservationsReservationsIdFulfillmentsNewHotelIndexRoute,
    reservationsReservationsIdFulfillmentsNewServiceIndexRoute:
      reservationsReservationsIdFulfillmentsNewServiceIndexRoute,
  }

const reservationsReservationsIdFulfillmentsRouteWithChildren =
  reservationsReservationsIdFulfillmentsRoute._addFileChildren(
    reservationsReservationsIdFulfillmentsRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  agenciesAgenciesRoute: agenciesAgenciesRouteWithChildren,
  departmentsDepartmentsRoute: departmentsDepartmentsRouteWithChildren,
  guidesGuidesRoute: guidesGuidesRouteWithChildren,
  hotelsHotelsRoute: hotelsHotelsRouteWithChildren,
  operationsOperationsRoute: operationsOperationsRoute,
  providersProvidersRoute: providersProvidersRouteWithChildren,
  regionsRegionsRoute: regionsRegionsRouteWithChildren,
  servicesServicesRoute: servicesServicesRouteWithChildren,
  toursToursRoute: toursToursRouteWithChildren,
  workersWorkersRoute: workersWorkersRouteWithChildren,
  hotelRoomsHotelRoomsIdRoute: hotelRoomsHotelRoomsIdRouteWithChildren,
  paymentAdjustmentsPaymentAdjustmentsIdRoute:
    paymentAdjustmentsPaymentAdjustmentsIdRouteWithChildren,
  paymentsPaymentsIdRoute: paymentsPaymentsIdRouteWithChildren,
  reservationsReservationsNewRoute: reservationsReservationsNewRoute,
  serviceProvidersServiceProvidersIdRoute:
    serviceProvidersServiceProvidersIdRouteWithChildren,
  tourAgenciesTourAgenciesIdRoute: tourAgenciesTourAgenciesIdRouteWithChildren,
  tourDaysTourDaysIdRoute: tourDaysTourDaysIdRoute,
  reservationsReservationsIndexRoute: reservationsReservationsIndexRoute,
  reservationsReservationsIdEditRoute: reservationsReservationsIdEditRoute,
  reservationsReservationsIdFulfillmentsRoute:
    reservationsReservationsIdFulfillmentsRouteWithChildren,
  reservationsReservationsIdIndexRoute: reservationsReservationsIdIndexRoute,
  reservationsReservationsCalendarIndexRoute:
    reservationsReservationsCalendarIndexRoute,
  reservationsReservationsCalendarIdEditRoute:
    reservationsReservationsCalendarIdEditRoute,
  reservationsReservationsCalendarIdFulfillmentsRoute:
    reservationsReservationsCalendarIdFulfillmentsRoute,
  reservationsReservationsCalendarIdIndexRoute:
    reservationsReservationsCalendarIdIndexRoute,
  reservationsReservationsCalendarNewIndexRoute:
    reservationsReservationsCalendarNewIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
